import React, {
  useState,
  useEffect,
  FC,
  useCallback,
  useRef,
  Children,
} from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Content from "../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Alert,
} from "reactstrap";
import Head from "../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
// import PurchaseOrderAside from "./PurchaseOrderAside";
import { FormProvider, set, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  ClockCircleOutlined,
  SmileTwoTone,
  MehOutlined,
  FileTextOutlined,
  SyncOutlined,
  ExclamationCircleTwoTone,
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";
import {
  Form,
  TableColumnsType,
  Input,
  InputNumber,
  Table,
  Popover,
  Collapse as AntCollapse,
  Button as AntButton,
  Descriptions,
  Modal as AntModal,
  Drawer,
  Upload,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Tag,
  Popconfirm,
  Checkbox,
  message,
} from "antd";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormTextArea from "../form-components/TextAreaComponent";
import FormDatePicker from "../form-components/DatePicker";
import misc from "../../api/misc/dropDowns";
import adminOrgApis from "../../api/master/adminOrg";
// import EditPoModal from "./EditPoModal";
import purchaseOrderApis from "../../api/purchase-order/PurchaseOrder";
import Swal from "sweetalert2";
import CropperComponent from "../components/CropperComponent";
// import SignatureModal from "./SignatureModal";
import dayjs from "dayjs";
// import QuotationApprovalDrawer from "./QuotationApprovalDrawer";
// import ChangeFromBuyerModal from "./ChangeFromBuyerModal";
// import statusMapper from "./StatusMapper";
import axios from "axios";
import { useSelector } from "react-redux";
import { formatCurrency, formatDecimal } from "../../utils/Utils";
// import PdfGenerator from "./TestPDF";
import EmailCreationModal from "../EmailCreationModal";
import { RootState } from "../../store/store";
import {
  MaterialOrService,
  ProductionSchedule,
  QuestionnaireSection,
  Tender,
} from "../../store/slices/tender/TenderList";
import tenderApis from "../../api/tender/tender";
import { ReactTyped } from "react-typed";
import { title } from "process";
import * as XLSX from "xlsx";
// @ts-ignore
import { saveAs } from "file-saver";
import ExportToXlsx from "../../utils/exportToXlsx";
import EditProductionScheduleTable from "./ProductionScheduleForm";
import EditShipmentScheduleTable from "./ShipmentScheduleForm";
import FormMultiSelect from "../form-components/MultiSelectComponent";

const { Panel } = AntCollapse;

interface BidScheduleRow {
  quantity: number;
  startDate: string;
  lagDays: number;
}

interface BidRowData {
  tenderMaterialId: number;
  materialName: string;
  category: string;
  requestedQuantity: number;
  supplyQuantity: number;
  supplierUnitPrice: number;
  installationCharges: number;
  discount: number;
  needByDate: string;
  planningStartDate: string;
  plannedLeadDays: number;
  taxType: string;
  taxPercentage: number;
  productionSchedules: BidScheduleRow[];
  shipmentSchedules: BidScheduleRow[];
  total: number;
}

interface ValidateBidResponse {
  status: boolean;
  statusCode: number;
  message: string;
  data: {
    rows: { jsonData: string; errors?: string }[];
    status: string;
    message: string;
  };
}

export const GetTenderStatusTag = ({ status }: any) => {
  const statusMap: Record<
    string,
    {
      color: string;
      label: string;
      icon: React.ReactNode;
    }
  > = {
    "New Tender": {
      color: "blue",
      label: "New Tender",
      icon: <ClockCircleOutlined />,
    },
    Interested: {
      color: "cyan",
      label: "Interested",
      icon: <></>,
    },
    "Not Interested": {
      color: "default",
      label: "Not Interested",
      icon: <MehOutlined />,
    },
    Responded: {
      color: "purple",
      label: "Responded",
      icon: <FileTextOutlined />,
    },
    Negotiation: {
      color: "orange",
      label: "Negotiation",
      icon: <SyncOutlined />,
    },
    "Partially Awarded": {
      color: "gold",
      label: "Partially Awarded",
      icon: <ExclamationCircleTwoTone twoToneColor="#faad14" />,
    },
    Awarded: {
      color: "green",
      label: "Awarded",
      icon: <CheckCircleTwoTone twoToneColor="#52c41a" />,
    },
    Cancelled: {
      color: "red",
      label: "Cancelled",
      icon: <CloseCircleTwoTone twoToneColor="#f5222d" />,
    },
  };

  const tagData = statusMap[status] || {
    color: "default",
    label: status,
    icon: <FileTextOutlined />,
  };

  return (
    <Tag
      icon={tagData.icon}
      color={tagData.color}
      style={{
        fontSize: 14,
      }}
      className="px-2"
    >
      {tagData.label}
    </Tag>
  );
};
const ViewTenderDetails: FC<{ tenderIdProp?: any; supplierBidStatusProp?: string; supplierIdProp?: number }> = ({ tenderIdProp, supplierBidStatusProp, supplierIdProp }) => {
  const termsAndConditionsAlertRef = useRef<HTMLDivElement>(null);
  const materialInfoAlertRef = useRef<HTMLDivElement>(null);
  const questionnaireAlertRef = useRef<HTMLDivElement>(null);
  const [materialInfoAlert, setMaterialInfoAlert] = useState<{
    open: boolean;
    message: string;
    type: "success" | "danger";
  }>({
    open: false,
    message: "",
    type: "success",
  });
  const [questionnaireInfoAlert, setQuestionnaireInfoAlert] = useState<{
    open: boolean;
    message: string;
    type: "success" | "danger";
  }>({
    open: false,
    message: "",
    type: "success",
  });
  const [termsAndConditionsInfoAlert, setTermsAndConditionsInfoAlert] =
    useState<{
      open: boolean;
      message: string;
      type: "success" | "danger";
    }>({
      open: false,
      message: "",
      type: "success",
    });
  const [mode, setMode] = useState("view");
  const location = useLocation();
  const { tenderId: locationTenderId, bidsSummary: navBidsSummary, supplierBidStatus: navSupplierBidStatus } = location.state || {};
  const tenderId = tenderIdProp || locationTenderId;
  const effectiveSupplierBidStatus = supplierBidStatusProp || navSupplierBidStatus;
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );

  const [popupCol, setPopupCol] = useState<string>("");

  const [openPricingInfoPopUp, setOpenPricingInfoPopUp] = useState<
    null | number
  >(null);
  const [editPriceInfo, setEditPriceInfo] = useState<boolean>(false);

  const [openServicePricingInfoPopUp, setOpenServicePricingInfoPopUp] =
    useState<null | number>(null);
  const [editServicePriceInfo, setEditServicePriceInfo] =
    useState<boolean>(false);

  const [openPlanningSchedulePopUp, setOpenPlanningSchedulePopUp] = useState<
    null | number
  >(null);
  const [editPlanningSchedule, setEditPlanningSchedule] =
    useState<boolean>(false);

  const [openProductionSchedulesPopUp, setOpenProductionSchedulesPopUp] =
    useState<null | number>(null);
  const [editProductionSchedules, setEditProductionSchedules] =
    useState<boolean>(false);

  const [openShipmentSchedulesPopUp, setOpenShipmentSchedulesPopUp] = useState<
    null | number
  >(null);
  const [editShipmentSchedules, setEditShipmentSchedules] =
    useState<boolean>(false);



  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("");
  const [TabsList, setTabsList] = useState<
    {
      tabKey: string;
      label: string;
    }[]
  >([]);

  const [questioners, setQuestioners] = useState<any>({});

  const [disableDiscard, setDisableDiscard] = useState(false);

  const [disableApprove, setDisableApprove] = useState(false);
  const [disableReject, setDisableReject] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>();
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [disapprovePO, setDisapprovePO] = useState<boolean>(false);
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [currentBidId, setCurrentBidId] = useState<number | null>(null);
  const [showCropModel, setShowCropModel] = useState<boolean>(false);
  const [signature, setSignature] = useState<any>([]);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");
  const [documents, setDocuments] = useState<any[]>([]);
  const [materialPageCurrent, setMaterialPageCurrent] = useState<number>(1);
  const [materialPageSize, setMaterialPageSize] = useState<number>(10);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const methods = useForm({
    mode: "onChange",
  });

  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const fileInputRef = useRef<HTMLInputElement>(null);
  const discountFileInputRef = useRef<HTMLInputElement>(null);
  const originalMaterialSnapshot = useRef<any[]>([]);

  // Discount drawer state
  const [discountDrawerOpen, setDiscountDrawerOpen] = useState(false);
  const [lineDiscounts, setLineDiscounts] = useState<Record<number, number>>({});
  const [discountRevisionReason, setDiscountRevisionReason] = useState("");
  const [discountReasonModalOpen, setDiscountReasonModalOpen] = useState(false);
  const [applyingDiscount, setApplyingDiscount] = useState(false);

  const handleExportMaterials = () => {
    if (!materialData || !Array.isArray(materialData) || materialData.length === 0) return;
    const category = OriginalData?.tenderFor || OriginalData?.category;
    const isMaterial = category === "Material" || category === "Materials";
    const showDiscount = OriginalData?.status === "Evaluated";

    const exportData = materialData.map((m: any, idx: number) => {
      const { pricingInfo, planningSchedules, productionSchedules, shipmentSchedules } = m;
      if (isMaterial) {
        const prodStr = (productionSchedules || [])
          .map((ps: any) => {
            const qty = ps.productionQuantity || "";
            const start = ps.plannedStartDate ? dayjs(ps.plannedStartDate).format("DD-MM-YYYY") : "";
            const lag = ps.productionLeadDays || "";
            return `(${qty}, ${start}, ${lag})`;
          })
          .join(",");
        const shipStr = (shipmentSchedules || [])
          .map((ss: any) => {
            const qty = ss.shippingQuantity || "";
            const date = ss.shippingDate ? dayjs(ss.shippingDate).format("DD-MM-YYYY") : "";
            const lag = ss.shippingLeadDays || "";
            return `(${qty}, ${date}, ${lag})`;
          })
          .join(",");
        return {
          "Id*": m.tenderMaterialId || m.materialId || "",
          "Category Name": m.categoryName || m.category || m.materialCategory || "",
          "Material Name*": m.materialName || m.materialCode || "",
          "Material Usage*": m.usage || m.materialUsage || "",
          "Requested Quantity": m.quantity || "",
          "Supply Quantity*": pricingInfo?.supplyQuantity || "",
          "Supplier Unit Price*": pricingInfo?.unitPrice || m.unitPrice || "",
          "Installation Required": m.isInstallationRequired ? "Yes" : "No",
          "Installation Charges*": pricingInfo?.installationCharges ?? "",
          ...(showDiscount ? { "Discount %*": pricingInfo?.discount ?? "" } : {}),
          "Need By Date": m.needByDate
            ? dayjs(m.needByDate).format("DD-MM-YYYY")
            : OriginalData?.lastSubmissionDate
              ? dayjs(OriginalData.lastSubmissionDate).format("DD-MM-YYYY")
              : "",
          "Planning Start Date*": planningSchedules?.startDate ? dayjs(planningSchedules.startDate).format("DD-MM-YYYY") : "",
          "Planned Lead Days*": planningSchedules?.plannedLeadDays || "",
          "Tax Type* (GST/VAT)": pricingInfo?.taxType || "",
          "Tax %*": pricingInfo?.taxPercentage || "",
          "Production Schedule(Quantity, Start Date, Lag Days)*": prodStr || "",
          "Shipment Schedule(Quantity, Shipment Date, Lag Days)*": shipStr || "",
        };
      }
      return {
        "Id*": m.tenderMaterialId || m.materialId || "",
        Category: m.categoryName || m.category || "",
        "Sub Category": m.subCategory || "",
        "Work Line": m.workLineName || "",
        "Supplier Unit Price*": pricingInfo?.unitPrice || m.unitPrice || "",
        "Working Days*": pricingInfo?.workingDays || "",
        "Tax Type* (GST/VAT)": pricingInfo?.taxType || "",
        "Tax %*": pricingInfo?.taxPercentage || "",
      };
    });

    // Reference data sheet for tax options
    const referenceData = [
      { "Tax Type": "GST", "Tax %": 0 },
      { "Tax Type": "GST", "Tax %": 1 },
      { "Tax Type": "GST", "Tax %": 5 },
      { "Tax Type": "GST", "Tax %": 12 },
      { "Tax Type": "GST", "Tax %": 15 },
      { "Tax Type": "GST", "Tax %": 18 },
      { "Tax Type": "GST", "Tax %": 28 },
      { "Tax Type": "VAT", "Tax %": 0 },
      { "Tax Type": "VAT", "Tax %": 1 },
      { "Tax Type": "VAT", "Tax %": 5 },
      { "Tax Type": "VAT", "Tax %": 12 },
      { "Tax Type": "VAT", "Tax %": 15 },
      { "Tax Type": "VAT", "Tax %": 18 },
      { "Tax Type": "VAT", "Tax %": 28 },
    ];

    const tenderNo = OriginalData?.tenderNumber || OriginalData?.tenderNo || "Tender";

    // Create workbook with 2 sheets: Materials + Reference
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wsRef = XLSX.utils.json_to_sheet(referenceData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Materials");
    XLSX.utils.book_append_sheet(wb, wsRef, "Reference - Tax Options");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${tenderNo}_Materials.xlsx`);
  };

  const handleImportMaterials = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // Reset input so the same file can be re-imported
    if (fileInputRef.current) fileInputRef.current.value = "";

    try {
      setIsLoading(true);
      const supplierId = supplierIdProp || currentUser?.supplierId;
      const formData = new FormData();
      formData.append("files", file);
      formData.append("tenderId", String(tenderId));
      if (supplierId) formData.append("supplierId", String(supplierId));



      const res = await tenderApis.validateBidBulkUpload(formData) as ValidateBidResponse;
      const resData = res?.data;

      if (!resData || resData?.status === "Error") {
        Swal.fire("Error", resData?.message || res?.message || "Validation failed", "error");
        return;
      }

      const rows = resData?.rows || [];
      if (!rows.length) {
        Swal.fire("Error", "No valid rows found in the uploaded file", "error");
        return;
      }

      // Separate valid rows from error rows
      const errorRows = rows.filter((r) => r.errors);
      const validRows = rows.filter((r) => !r.errors);

      // Parse only valid rows' jsonData and map to materialData by tenderMaterialId
      const parsedRows: BidRowData[] = validRows.map((r) => {
        try {
          return typeof r.jsonData === "string" ? JSON.parse(r.jsonData) : r.jsonData;
        } catch { return null; }
      }).filter(Boolean);

      // Build a map of errors by tenderMaterialId
      const errorMap = new Map<number, string>();
      errorRows.forEach((r) => {
        try {
          const parsed = typeof r.jsonData === "string" ? JSON.parse(r.jsonData) : r.jsonData;
          if (parsed?.tenderMaterialId) {
            errorMap.set(parsed.tenderMaterialId, r.errors || "Validation error");
          }
        } catch {}
      });

      const updatedMaterials = materialData.map((m: any) => {
        // Set or clear import error for this material
        const importError = errorMap.get(m.tenderMaterialId) || null;

        const row = parsedRows.find(
          (r) => r.tenderMaterialId === m.tenderMaterialId
        );
        if (!row) return { ...m, _importError: importError };

        const updated = { ...m };
        updated.pricingInfo = {
          ...m.pricingInfo,
          supplyQuantity: row.supplyQuantity,
          unitPrice: row.supplierUnitPrice,
          installationCharges: row.installationCharges,
          ...(row.discount != null ? { discount: row.discount } : {}),
          taxType: row.taxType,
          taxPercentage: row.taxPercentage,
        };
        updated.unitPrice = row.supplierUnitPrice;

        // Planning Schedule
        if (row.planningStartDate || row.plannedLeadDays) {
          updated.planningSchedules = {
            ...(m.planningSchedules || {}),
            startDate: row.planningStartDate,
            plannedLeadDays: row.plannedLeadDays,
            endDate: row.planningStartDate && row.plannedLeadDays
              ? dayjs(row.planningStartDate).add(row.plannedLeadDays, "day").format("YYYY-MM-DD")
              : m.planningSchedules?.endDate,
          };
        }

        // Production Schedules
        if (row.productionSchedules?.length) {
          updated.productionSchedules = row.productionSchedules.map((ps: BidScheduleRow, i: number) => ({
            ...(m.productionSchedules?.[i] || {}),
            key: m.productionSchedules?.[i]?.key || `ps-${i}`,
            productionQuantity: ps.quantity,
            plannedStartDate: ps.startDate,
            productionLeadDays: ps.lagDays,
            plannedEndDate: ps.startDate && ps.lagDays
              ? dayjs(ps.startDate).add(ps.lagDays, "day").format("YYYY-MM-DD")
              : undefined,
          }));
        }

        // Shipment Schedules
        if (row.shipmentSchedules?.length) {
          updated.shipmentSchedules = row.shipmentSchedules.map((ss: BidScheduleRow, i: number) => ({
            ...(m.shipmentSchedules?.[i] || {}),
            key: m.shipmentSchedules?.[i]?.key || `ss-${i}`,
            shippingQuantity: ss.quantity,
            shippingDate: ss.startDate,
            shippingLeadDays: ss.lagDays,
            shippingEndDate: ss.startDate && ss.lagDays
              ? dayjs(ss.startDate).add(ss.lagDays, "day").format("YYYY-MM-DD")
              : undefined,
          }));
        }

        updated._importError = null; // Clear error for successfully imported rows
        return updated;
      });

      // Deduplicate after import: trim, remove spaces, lowercase materialName/usage + materialId
      const deduplicatedImport = (() => {
        const seen = new Set<string>();
        return updatedMaterials.filter((m: any) => {
          const namePart = (m.materialName || m.usage || m.workLineName || "")
            .trim()
            .replace(/\s+/g, "")
            .toLowerCase();
          const idPart = String(m.tenderMaterialId || m.materialId || m.lineNo || "");
          const key = `${namePart}_${idPart}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      })();
      setMaterialData(deduplicatedImport);
      setMaterialPageCurrent(1);

      if (errorRows.length > 0 && validRows.length === 0) {
        Swal.fire("Import Failed", `All ${errorRows.length} rows have errors. Check the error messages on each row in the table.`, "error");
      } else if (errorRows.length > 0) {
        Swal.fire({
          title: "Partially Imported",
          html: `<b>${validRows.length}</b> of ${rows.length} rows imported.<br/><b style="color:#dc3545">${errorRows.length}</b> rows have errors — check the table for details.`,
          icon: "warning",
        });
      } else {
        Swal.fire("Success", `${validRows.length} rows imported successfully`, "success");
      }
    } catch (error: any) {
      console.error("Import error:", error);
      Swal.fire("Error", error?.message || "Failed to import. Please check the file format.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  // --- Discount Drawer Functions ---
  const getDiscountDrawerMaterials = () => {
    if (!materialData || !Array.isArray(materialData)) return [];
    return materialData
      .filter((m: any) => m.bidMaterialId)
      .map((m: any, idx: number) => {
        const price = m?.pricingInfo?.unitPrice ?? m?.unitPrice ?? 0;
        const qty = m?.pricingInfo?.supplyQuantity ?? m?.quantity ?? 0;
        const installation = Number(m?.pricingInfo?.installationCharges || 0);
        const totalPrice = Number(qty) * Number(price) + Number(qty) * installation;
        return {
          key: String(idx),
          tenderMaterialId: m.tenderMaterialId,
          bidMaterialId: m.bidMaterialId,
          materialName: m.materialName || m.materialCode || "",
          usage: m.usage || m.materialUsage || "",
          supplyQty: qty,
          unitPrice: price,
          installationCharges: installation,
          totalPrice,
        };
      });
  };

  const handleDiscountExport = () => {
    const materials = getDiscountDrawerMaterials();
    if (!materials.length) return;
    const exportData = materials.map((mat: any) => ({
      "Bid Material Id": mat.bidMaterialId,
      "Material Name": mat.materialName,
      "Usage": mat.usage,
      "Supply Qty": mat.supplyQty,
      "Unit Price": mat.unitPrice,
      "Installation Charges": mat.installationCharges,
      "Total Price": mat.totalPrice,
      "Discount %": lineDiscounts[mat.tenderMaterialId] || "",
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Discount");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Discount_Materials.xlsx`);
  };

  const handleDiscountImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (discountFileInputRef.current) discountFileInputRef.current.value = "";
    try {
      const supplierId = supplierIdProp || currentUser?.supplierId;
      const supplierBidId = currentBidId ||
        OriginalData?.bidDetails?.supplierBidId ||
        OriginalData?.bidsSummary?.[0]?.bidId;

      const formData = new FormData();
      formData.append("files", file);
      formData.append("tenderId", String(tenderId));
      if (supplierBidId) formData.append("bidId", String(supplierBidId));
      formData.append("bidType", "supplier");

      const response: any = await tenderApis.validateDiscountBulkUpload(formData);
      const responseData = response?.data || response || {};
      const rows = responseData?.rows || responseData || [];

      if (responseData?.status === "VALIDATION_ERRORS") {
        const errorMessages = (Array.isArray(rows) ? rows : [])
          .filter((row: any) => row.errors)
          .map((row: any) => {
            const parsed = typeof row.jsonData === "string" ? JSON.parse(row.jsonData) : row;
            return `${parsed.lineName || "Unknown"}: ${row.errors}`;
          });
        if (errorMessages.length > 0) {
          Swal.fire("Validation Errors", errorMessages.join("<br/>"), "error");
          return;
        }
      }

      const materials = getDiscountDrawerMaterials();
      const newDiscounts: Record<number, number> = { ...lineDiscounts };
      let importedCount = 0;

      (Array.isArray(rows) ? rows : []).forEach((row: any) => {
        const parsed = typeof row.jsonData === "string" ? JSON.parse(row.jsonData) : row;
        if (parsed.discountPercentage > 0 && parsed.lineId > 0 && !row.errors) {
          const matchedMat = materials.find((m: any) => m.bidMaterialId === parsed.lineId);
          if (matchedMat) {
            newDiscounts[matchedMat.tenderMaterialId] = parsed.discountPercentage;
            importedCount++;
          }
        }
      });

      setLineDiscounts(newDiscounts);
      Swal.fire("Success", `Imported discounts for ${importedCount} materials`, "success");
    } catch (error: any) {
      console.error("Discount import error:", error);
      Swal.fire("Error", "Failed to import discount file", "error");
    }
  };

  const handleApplyDiscountClick = () => {
    const entries = Object.entries(lineDiscounts).filter(([_, val]) => val > 0);
    if (entries.length === 0) {
      Swal.fire("Warning", "Please enter discount % for at least one material.", "warning");
      return;
    }
    setDiscountReasonModalOpen(true);
  };

  const handleApplyAllDiscounts = async () => {
    if (!discountRevisionReason.trim()) {
      Swal.fire("Warning", "Please enter a reason for the discount.", "warning");
      return;
    }
    const entries = Object.entries(lineDiscounts).filter(([_, val]) => val > 0);
    const supplierBidId = currentBidId ||
      OriginalData?.bidDetails?.supplierBidId ||
      OriginalData?.bidsSummary?.[0]?.bidId;
    if (!supplierBidId) {
      Swal.fire("Error", "Bid ID not found.", "error");
      return;
    }
    try {
      setDiscountReasonModalOpen(false);
      setApplyingDiscount(true);
      const materials = getDiscountDrawerMaterials();
      const materialDiscounts = entries.map(([matId, val]) => {
        const mat = materials.find((m: any) => m.tenderMaterialId === Number(matId));
        return {
          bidMaterialId: mat?.bidMaterialId,
          discountPercent: val,
        };
      });

      await tenderApis.applyDiscount(tenderId, supplierBidId, {
        materialDiscounts,
        revisionReason: discountRevisionReason.trim(),
      });

      Swal.fire("Success", "Discounts applied successfully!", "success");
      setLineDiscounts({});
      setDiscountRevisionReason("");
      setDiscountDrawerOpen(false);
      await fetchOrderDetails();
    } catch (error: any) {
      console.error("Error applying discounts:", error);
      Swal.fire("Error", error?.response?.data?.message || "Failed to apply discounts", "error");
    } finally {
      setApplyingDiscount(false);
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };

  const fetchOrderDetails = async (submittedBidId?: number) => {
    try {
      setIsLoading(true);
      const res: any = await tenderApis.fetchTenderById(tenderId);
      let CurrentTender = res?.data || res;

      // Only use prop/nav status as fallback when API doesn't return supplierBidStatus
      if (effectiveSupplierBidStatus && !CurrentTender?.supplierBidStatus) {
        CurrentTender.supplierBidStatus = effectiveSupplierBidStatus;
      }

      // Check supplier bid status to get bidId and updated status (only for public link mode)
      const supplierId = supplierIdProp || currentUser?.supplierId;
      let resolvedBidId = null;

      if (tenderIdProp && supplierId) {
        try {
          const bidStatusRes: any = await tenderApis.checkSupplierBidStatus(tenderId, supplierId);
          const bidStatusData = bidStatusRes?.data || bidStatusRes?.response?.data || bidStatusRes;
          if (bidStatusData?.bidId) {
            resolvedBidId = bidStatusData.bidId;
          }
          // Update supplierBidStatus from check-supplier-bid-status response
          if (bidStatusData?.status) {
            CurrentTender.supplierBidStatus = bidStatusData.status;
          }
        } catch (e) {
          console.log("checkSupplierBidStatus failed:", e);
        }
      }

      // Fallback to bidsSummary or submittedBidId
      if (!resolvedBidId) {
        const bidSummary = CurrentTender?.bidsSummary?.[0] || navBidsSummary?.[0];
        resolvedBidId = bidSummary?.bidId || submittedBidId;
      }

      // Fetch tender-with-bid for richer data if bidId is available
      if (resolvedBidId) {
        setCurrentBidId(resolvedBidId);
        const bidType = "Supplier";
        const bidRes: any = await tenderApis.getTenderWithBid(
          tenderId,
          resolvedBidId,
          bidType
        );
        const bidData = bidRes?.data || bidRes;
        if (bidData) {
          // Merge bid materials with original materials to preserve fields
          // like categoryName, usage, needByDate that tender-with-bid doesn't return
          const originalMaterials = CurrentTender?.materials || CurrentTender?.materialsOrServices || [];
          const bidMaterials = bidData?.materials || bidData?.materialsOrServices || [];
          if (originalMaterials.length > 0) {
            const mergedMaterials = originalMaterials.map((orig: any) => {
              const bm = bidMaterials.find(
                (b: any) => b.tenderMaterialId === orig.tenderMaterialId
              );
              return bm ? { ...orig, ...bm } : orig;
            });
            bidData.materials = mergedMaterials;
          }
          // Preserve original documents — bidData may not include them
          const originalDocuments = CurrentTender?.documents;
          CurrentTender = { ...CurrentTender, ...bidData };
          if (originalDocuments && !CurrentTender.documents?.length) {
            CurrentTender.documents = originalDocuments;
          }
        }
      }

      const {
        materials,
        materialsOrServices,
        questionnaireSections,
        Questionnaires,
        validateDate,
      } = CurrentTender || {};
      const resetFormObj: any = {
        validateDate,
      };

      setOriginalData(CurrentTender);

      // Map bidResponse fields to top-level material fields for UI compatibility
      const rawMaterials = materials || materialsOrServices;
      const processedMaterials = rawMaterials?.map((m: any, idx: number) => {
        const br = m.bidResponse || {};
        return {
          ...m,
          lineNo: m.lineNo || idx + 1,
          unitPrice: br.unitPrice ?? m.unitPrice,
          bidMaterialId: br.bidMaterialId ?? m.bidMaterialId,
          pricingInfo: {
            ...m.pricingInfo,
            ...(br.unitPrice != null && { unitPrice: br.unitPrice }),
            ...(br.taxType != null && { taxType: br.taxType }),
            ...(br.taxPercentage != null && { taxPercentage: br.taxPercentage }),
            ...(br.suppliedQuantity != null && { supplyQuantity: br.suppliedQuantity }),
            ...(br.installationCharges != null && { installationCharges: br.installationCharges }),
            ...((br.discount ?? br.discountPercent) != null && { discount: br.discount ?? br.discountPercent }),
          },
          planningSchedules: br.planningSchedules?.[0]
            ? {
              planningScheduleId: br.planningSchedules[0].planningScheduleId,
              startDate: br.planningSchedules[0].startDate,
              endDate: br.planningSchedules[0].endDate,
              plannedLeadDays: br.planningSchedules[0].leadDays,
            }
            : m.planningSchedules,
          productionSchedules: br.productionSchedules?.length
            ? br.productionSchedules.map((ps: any, i: number) => ({
              key: ps.productionScheduleId || `ps-${i}`,
              productionScheduleId: ps.productionScheduleId,
              productionQuantity: ps.productionQuantity,
              plannedStartDate: ps.plannedStartDate,
              plannedEndDate: ps.plannedEndDate,
              productionLeadDays: ps.leadDays,
            }))
            : m.productionSchedules,
          shipmentSchedules: br.shipmentSchedules?.length
            ? br.shipmentSchedules.map((ss: any, i: number) => ({
              key: ss.shipmentScheduleId || `ss-${i}`,
              shipmentScheduleId: ss.shipmentScheduleId,
              shippingQuantity: ss.shippingQuantity,
              shippingDate: ss.shippingStartDate,
              shippingEndDate: ss.shippingEndDate,
              shippingLeadDays: ss.lagDays,
            }))
            : m.shipmentSchedules,
        };
      });
      // Deduplicate materials: trim, remove spaces, lowercase materialName/usage + materialId
      const deduplicatedMaterials = (() => {
        if (!processedMaterials || !Array.isArray(processedMaterials)) return processedMaterials;
        const seen = new Set<string>();
        return processedMaterials.filter((m: any) => {
          const namePart = (m.materialName || m.usage || m.workLineName || "")
            .trim()
            .replace(/\s+/g, "")
            .toLowerCase();
          const idPart = String(m.tenderMaterialId || m.materialId || m.lineNo || "");
          const key = `${namePart}_${idPart}`;
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
      })();
      setMaterialData(deduplicatedMaterials);
      // Save snapshot of material data for detecting changes during update
      originalMaterialSnapshot.current = JSON.parse(JSON.stringify(deduplicatedMaterials || []));

      // Support both API formats: questionnaireSections (API) and Questionnaires (old)
      const sections = questionnaireSections || Questionnaires;
      if (sections && sections?.length > 0) {
        const questioner: any = {};
        const tabsList: {
          tabKey: string;
          label: string;
        }[] = [];
        sections.forEach((item: any) => {
          const questionerSectionId = item?.sectionName.replace(/\s/g, "");
          const sectionWeightage = item.weightage ?? item.totalWeightage ?? 0;
          tabsList.push({
            tabKey: questionerSectionId,
            label: item.sectionName + " (" + sectionWeightage + "%)",
          });
          questioner[`${questionerSectionId}`] = {
            sectionName: item.sectionName,
            totalWeightage: sectionWeightage,
            tenderSectionId: item.tenderSectionId,
          };
          const Questions: any = [];
          item.questions.forEach((question: any, index: number) => {
            // For Multiple Choice, use selectedOptions; for others use answerText
            const bidAnswer = question.bidAnswer;
            let resolvedAnswer = question.answer;
            if (bidAnswer) {
              if (question.type === "Multiple Choice" && bidAnswer.selectedOptions?.length > 0) {
                resolvedAnswer = bidAnswer.selectedOptions;
              } else {
                resolvedAnswer = bidAnswer.answerText ?? question.answer;
              }
            }
            Questions.push({
              questionId: questionerSectionId + "--" + index,
              tenderQuestionId: question.tenderQuestionId,
              description: question.question || question.description,
              type: question.type,
              mandatory: question.mandatory,
              weightage: question.weightage,
              options: question.options,
              answer: resolvedAnswer,
              remarks: bidAnswer?.remarks ?? question.remarks,
            });
            resetFormObj[`${questionerSectionId}--${index}`] = resolvedAnswer;
            resetFormObj[`${questionerSectionId}--${index}--remarks`] =
              question.bidAnswer?.remarks ?? question.remarks;
          });
          questioner[`${questionerSectionId}`].questions = Questions;
        });

        setQuestioners(questioner);
        setTabsList(tabsList);
        setActiveTab(tabsList[0].tabKey);
      }

      // Set documents if available from API response
      if (CurrentTender?.documents) {
        setDocuments(CurrentTender.documents);
        // Fetch Terms and Conditions & Instructions from document URLs
        CurrentTender.documents.forEach(async (doc: any) => {
          if (doc.filePath) {
            try {
              const response = await fetch(doc.filePath);
              const htmlContent = await response.text();
              if (doc.moduleFileType === "TermsAndConditions") {
                setTermsAndConditions(htmlContent);
              } else if (doc.moduleFileType === "Instructions") {
                setInstructions(htmlContent);
              }
            } catch (err) {
              console.log("Error fetching document:", doc.moduleFileType, err);
            }
          }
        });
      }

      reset(resetFormObj);

      setShowSubmitBtm(false);

      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const ShowAddressPopOver = ({ address }: any) => {
    return (
      <ul>
        <li>{address.addressLine1}</li>
        <li>{address.addressLine2}</li>
        <li>
          {address.city}, {address.stateName}, {address.countryName} -{" "}
          {address.pincode}
        </li>
      </ul>
    );
  };

  useEffect(() => {
    fetchOrderDetails();
  }, [tenderId]);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const rejectTender = async (rejectedReason: string) => {
    try {
      const res = await tenderApis.expressInterest(tenderId, {
        interestStatus: "Not Interested",
        supplierId: supplierIdProp || currentUser?.supplierId,
        remarks: rejectedReason,
      });
      const resData = res?.response?.data || res;
      if (resData?.status === false) {
        Swal.fire("Error", resData?.message || "Failed to mark as Not Interested", "error");
        return;
      }
      Swal.fire(
        "Success",
        resData?.message || "Tender marked as Not Interested",
        "success"
      );
      fetchOrderDetails();
    } catch (error: any) {
      const errMsg = error?.response?.data?.message || "Something went wrong";
      Swal.fire("Error", errMsg, "error");
    }
    setDisableReject(false);
  };

  const ApproveTender = async () => {
    try {
      const res = await tenderApis.expressInterest(tenderId, {
        interestStatus: "Interested",
        supplierId: supplierIdProp || currentUser?.supplierId,
      });
      const resData = res?.response?.data || res;
      if (resData?.status === false) {
        Swal.fire("Error", resData?.message || "Failed to express interest", "error");
        return;
      }
      Swal.fire(
        "Success",
        resData?.message || "Your Interest for this tender is submitted",
        "success"
      ).then(async () => {
        if (tenderIdProp) {
          // Public link mode — stay on the page, refresh data and enter edit/bid mode
          await fetchOrderDetails();
          setMode("edit");
        } else {
          navigate("/home");
        }
      });
    } catch (error: any) {
      const errMsg = error?.response?.data?.message || "Something went wrong";
      Swal.fire("Error", errMsg, "error");
    } finally {
      setDisableApprove(false);
    }
  };

  const isMaterialFilled = (material: MaterialOrService, OriginalData: any) => {
    const { pricingInfo } = material;
    const { unitPrice, supplyQuantity } = pricingInfo || {};
    if (OriginalData?.tenderFor == "Material" || OriginalData?.category == "Materials") {
      return !!(unitPrice && supplyQuantity);
    } else {
      return !!unitPrice;
    }
  };

  const ValidateMaterialsData = (
    materialData: MaterialOrService[],
    OriginalData: any
  ) => {
    try {
      const alertStatus = {
        open: false,
        message: "",
        type: "danger" as any,
      };

      // Check at least one material is filled
      const filledMaterials = materialData.filter((m) => isMaterialFilled(m, OriginalData));
      if (filledMaterials.length === 0) {
        alertStatus.open = true;
        alertStatus.message = "Please fill in at least one material to submit the bid";
        materialInfoAlertRef?.current?.scrollIntoView({ behavior: "smooth" });
        setMaterialInfoAlert(alertStatus);
        return false;
      }

      // Validate only filled materials
      for (let material of filledMaterials) {
        const {
          category,
          materialName,
          pricingInfo,
          planningSchedules,
          productionSchedules,
          shipmentSchedules,
        } = material;
        const {
          isUnitPriceNegotiable,
          unitPrice,
          taxType,
          taxPercentage,
          supplyQuantity,
          workingDays,
        } = pricingInfo || {};
        const { startDate, endDate, plannedLeadDays } = planningSchedules || {};
        if (OriginalData?.tenderFor == "Material" || OriginalData?.category == "Materials") {
          if (!unitPrice) {
            alertStatus.open = true;
            alertStatus.message = materialName + ": Unit Price is required";
            break;
          }

          if (!supplyQuantity) {
            alertStatus.open = true;
            alertStatus.message =
              materialName + ": Supply Quantity is required";
            break;
          }
          if (!startDate || !plannedLeadDays) {
            alertStatus.open = true;
            alertStatus.message =
              materialName + ": Start Date and Planned Lead Days is required";
            break;
          }
          if (!productionSchedules || productionSchedules?.length <= 0) {
            alertStatus.open = true;
            alertStatus.message =
              materialName + ": Production Schedule is required";
            break;
          }
          if (!shipmentSchedules || shipmentSchedules?.length <= 0) {
            alertStatus.open = true;
            alertStatus.message =
              materialName + ": Shipment Schedule is required";
            break;
          }
          if (!taxType || !taxPercentage) {
            alertStatus.open = true;
            alertStatus.message =
              materialName + ": Tax Type and Tax Percentage is required";
            break;
          }
        } else {
          if (!unitPrice) {
            alertStatus.open = true;
            alertStatus.message = category + ": Unit Price is required";
            break;
          }
          if (!taxType || !taxPercentage) {
            alertStatus.open = true;
            alertStatus.message =
              category + ": Tax Type and Tax Percentage is required";
            break;
          }
          if (!workingDays) {
            alertStatus.open = true;
            alertStatus.message = category + ": Working Days is required";
            break;
          }
        }
      }

      if (alertStatus.open) {
        materialInfoAlertRef?.current?.scrollIntoView({
          behavior: "smooth",
        });
        setMaterialInfoAlert(alertStatus);
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  };

  const SubmitChanges = async (formData: any) => {
    try {
      const { validateDate } = formData;

      // Build questionnaire answers for bid API
      const questionaries: any[] = [];
      Object?.keys(questioners)?.forEach((questionerSectionId: any) => {
        const item = questioners[questionerSectionId];
        item.questions.forEach((question: any) => {
          const answer = formData[question.questionId];
          const remarks = formData[`${question.questionId}--remarks`];
          questionaries.push({
            tenderQuestionId: question.tenderQuestionId || question.questionId,
            tenderSectionId: item.tenderSectionId || 0,
            answerText: typeof answer === "string" ? answer : undefined,
            answerBoolean: typeof answer === "boolean" ? answer : undefined,
            selectedOptions: Array.isArray(answer) ? answer : undefined,
            remarks,
          });
        });
      });

      // Build materials for bid API — only include filled materials
      const filledMaterialData = materialData?.filter((m: any) => isMaterialFilled(m, OriginalData));
      const materials = filledMaterialData?.map((material: any) => ({
        tenderMaterialId: material.tenderMaterialId || material.lineNo,
        suppliedQuantity: material.pricingInfo?.supplyQuantity || 0,
        unitPrice: material.pricingInfo?.unitPrice || 0,
        installationCharges: material.pricingInfo?.installationCharges || 0,
        priceChangeAllowed: true,
        taxType: material.pricingInfo?.taxType,
        taxPercentage: material.pricingInfo?.taxPercentage || 0,
        deliveryLeadDays: material.planningSchedules?.plannedLeadDays,
        remarks: material.remarks,
        planningSchedules: material.planningSchedules
          ? [
            {
              tenderMaterialId: material.tenderMaterialId || material.lineNo,
              startDate: material.planningSchedules.startDate,
              endDate: material.planningSchedules.endDate,
              leadDays: material.planningSchedules.plannedLeadDays,
            },
          ]
          : [],
        productionSchedules:
          material.productionSchedules?.map((ps: any) => {
            const startDate = ps.plannedStartDate
              ? dayjs(ps.plannedStartDate).format("YYYY-MM-DD")
              : "";
            const endDate =
              ps.plannedStartDate && ps.productionLeadDays
                ? dayjs(ps.plannedStartDate)
                  .add(ps.productionLeadDays, "day")
                  .format("YYYY-MM-DD")
                : ps.plannedEndDate
                  ? dayjs(ps.plannedEndDate).format("YYYY-MM-DD")
                  : "";
            return {
              tenderMaterialId: material.tenderMaterialId || material.lineNo,
              plannedStartDate: startDate,
              plannedEndDate: endDate,
              productionQuantity: ps.productionQuantity,
              leadDays: ps.productionLeadDays,
            };
          }) || [],
        shipmentSchedules:
          material.shipmentSchedules?.map((ss: any) => {
            const startDate = ss.shippingDate
              ? dayjs(ss.shippingDate).format("YYYY-MM-DD")
              : "";
            const endDate =
              ss.shippingDate && ss.shippingLeadDays
                ? dayjs(ss.shippingDate)
                  .add(ss.shippingLeadDays, "day")
                  .format("YYYY-MM-DD")
                : ss.shippingEndDate
                  ? dayjs(ss.shippingEndDate).format("YYYY-MM-DD")
                  : "";
            return {
              tenderMaterialId: material.tenderMaterialId || material.lineNo,
              shippingStartDate: startDate,
              shippingEndDate: endDate,
              estimatedArrival: endDate,
              shippingQuantity: ss.shippingQuantity,
              lagDays: ss.shippingLeadDays,
            };
          }) || [],
      }));

      const bidData: any = {
        supplierId: currentUser?.supplierId,
        validityDate: validateDate
          ? dayjs(validateDate).toISOString()
          : undefined,
        tcAccepted: isTermsAccepted,
        materials,
        questionaries,
      };

      const formDataPayload = new FormData();
      formDataPayload.append("bid", JSON.stringify(bidData));

      const res = await tenderApis.submitBid(tenderId, formDataPayload);
      const resData = res?.response?.data || res;
      if (resData?.status === false) {
        Swal.fire("Error", resData?.message || "Failed to submit bid", "error");
        return;
      }
      // Extract bidId from submit response for subsequent getTenderWithBid call
      const submittedBidId = resData?.bidId || resData?.data?.bidId || resData?.response?.bidId;
      if (submittedBidId) setCurrentBidId(submittedBidId);
      Swal.fire(
        "Success",
        resData?.message || "Bid submitted successfully",
        "success"
      ).then(async () => {
        if (tenderIdProp) {
          // Public link mode — stay on the page, refresh data and switch to view mode
          await fetchOrderDetails(submittedBidId);
          setMode("view");
        } else {
          navigate("/home");
        }
      });
    } catch (error: any) {
      const errMsg = error?.response?.data?.message || "Something went wrong";
      Swal.fire("Error", errMsg, "error");
    } finally {
      setDisableSubmit(false);
    }
  };

  const UpdateBidChanges = async (formData: any, revisionReason?: string) => {
    try {
      const supplierBidId = currentBidId ||
        OriginalData?.bidDetails?.supplierBidId ||
        OriginalData?.bidsSummary?.[0]?.bidId;

      if (!supplierBidId) {
        Swal.fire("Error", "Bid ID not found. Cannot update bid.", "error");
        setDisableSubmit(false);
        return;
      }

      const filledMaterials = materialData?.filter((m: any) => isMaterialFilled(m, OriginalData)) || [];
      const unfilledMaterials = materialData?.filter((m: any) => !isMaterialFilled(m, OriginalData)) || [];

      // Build materials array — only include changed fields per line
      const materials: any[] = [];
      const materialDiscounts: any[] = [];
      for (const material of filledMaterials) {
        const origMat = originalMaterialSnapshot.current.find(
          (o: any) => o.tenderMaterialId === material.tenderMaterialId
        );
        const wasPreviouslyFilled = origMat && isMaterialFilled(origMat, OriginalData);

        // Check discount change for all filled materials (before branching)
        const pi_disc = Number(material?.pricingInfo?.discount || 0);
        const opi_disc = Number(origMat?.pricingInfo?.discount || 0);
        if (pi_disc !== opi_disc && material.bidMaterialId) {
          materialDiscounts.push({
            bidMaterialId: material.bidMaterialId,
            discountPercent: pi_disc,
          });
        }

        if (!wasPreviouslyFilled) {
          // Re-linking — send full object with tenderMaterialId (required fields for new line)
          materials.push({
            tenderMaterialId: material.tenderMaterialId || material.lineNo,
            suppliedQuantity: material.pricingInfo?.supplyQuantity || 0,
            unitPrice: material.pricingInfo?.unitPrice || 0,
            installationCharges: material.pricingInfo?.installationCharges || 0,
            priceChangeAllowed: true,
            taxType: material.pricingInfo?.taxType,
            taxPercentage: material.pricingInfo?.taxPercentage || 0,
            deliveryLeadDays: material.planningSchedules?.plannedLeadDays,
            remarks: material.remarks,
            planningSchedules: material.planningSchedules
              ? [{
                tenderMaterialId: material.tenderMaterialId || material.lineNo,
                startDate: material.planningSchedules.startDate,
                endDate: material.planningSchedules.endDate,
                leadDays: material.planningSchedules.plannedLeadDays,
              }]
              : [],
            productionSchedules:
              material.productionSchedules?.map((ps: any) => ({
                tenderMaterialId: material.tenderMaterialId || material.lineNo,
                plannedStartDate: ps.plannedStartDate ? dayjs(ps.plannedStartDate).format("YYYY-MM-DD") : "",
                plannedEndDate: ps.plannedStartDate && ps.productionLeadDays
                  ? dayjs(ps.plannedStartDate).add(ps.productionLeadDays, "day").format("YYYY-MM-DD")
                  : ps.plannedEndDate ? dayjs(ps.plannedEndDate).format("YYYY-MM-DD") : "",
                productionQuantity: ps.productionQuantity,
                leadDays: ps.productionLeadDays,
              })) || [],
            shipmentSchedules:
              material.shipmentSchedules?.map((ss: any) => ({
                tenderMaterialId: material.tenderMaterialId || material.lineNo,
                shippingStartDate: ss.shippingDate ? dayjs(ss.shippingDate).format("YYYY-MM-DD") : "",
                shippingEndDate: ss.shippingDate && ss.shippingLeadDays
                  ? dayjs(ss.shippingDate).add(ss.shippingLeadDays, "day").format("YYYY-MM-DD")
                  : ss.shippingEndDate ? dayjs(ss.shippingEndDate).format("YYYY-MM-DD") : "",
                estimatedArrival: ss.shippingDate && ss.shippingLeadDays
                  ? dayjs(ss.shippingDate).add(ss.shippingLeadDays, "day").format("YYYY-MM-DD")
                  : ss.shippingEndDate ? dayjs(ss.shippingEndDate).format("YYYY-MM-DD") : "",
                shippingQuantity: ss.shippingQuantity,
                lagDays: ss.shippingLeadDays,
              })) || [],
          });
          continue;
        }

        // Existing bid line — only send changed fields
        const pi = material?.pricingInfo || {};
        const opi = origMat?.pricingInfo || {};
        const matPayload: any = { bidMaterialId: material.bidMaterialId };
        let hasChanges = false;

        // Compare pricing fields
        if (Number(pi.suppliedQuantity ?? pi.supplyQuantity ?? 0) !== Number(opi.suppliedQuantity ?? opi.supplyQuantity ?? 0)) {
          matPayload.suppliedQuantity = pi.supplyQuantity || 0;
          hasChanges = true;
        }
        if (Number(pi.unitPrice || 0) !== Number(opi.unitPrice || 0)) {
          matPayload.unitPrice = pi.unitPrice || 0;
          hasChanges = true;
        }
        if (Number(pi.installationCharges || 0) !== Number(opi.installationCharges || 0)) {
          matPayload.installationCharges = pi.installationCharges || 0;
          hasChanges = true;
        }
        if ((pi.taxType || "") !== (opi.taxType || "")) {
          matPayload.taxType = pi.taxType;
          hasChanges = true;
        }
        if (Number(pi.taxPercentage || 0) !== Number(opi.taxPercentage || 0)) {
          matPayload.taxPercentage = pi.taxPercentage || 0;
          hasChanges = true;
        }
        if ((material.remarks || "") !== (origMat.remarks || "")) {
          matPayload.remarks = material.remarks;
          hasChanges = true;
        }

        // Compare planning schedules
        if (JSON.stringify(material?.planningSchedules || {}) !== JSON.stringify(origMat?.planningSchedules || {})) {
          matPayload.planningSchedules = material.planningSchedules
            ? [{
              ...(material.planningSchedules.planningScheduleId && { planningScheduleId: material.planningSchedules.planningScheduleId }),
              tenderMaterialId: material.tenderMaterialId || material.lineNo,
              startDate: material.planningSchedules.startDate,
              endDate: material.planningSchedules.endDate,
              leadDays: material.planningSchedules.plannedLeadDays,
            }]
            : [];
          // Detect deleted planning schedules
          const origPlanningId = origMat?.planningSchedules?.planningScheduleId;
          const currPlanningId = material?.planningSchedules?.planningScheduleId;
          if (origPlanningId && origPlanningId !== currPlanningId) {
            matPayload.deletedPlanningSchedules = [origPlanningId];
          }
          hasChanges = true;
        }

        // Compare production schedules
        if (JSON.stringify(material?.productionSchedules || []) !== JSON.stringify(origMat?.productionSchedules || [])) {
          matPayload.productionSchedules = material.productionSchedules?.map((ps: any) => ({
            ...(ps.productionScheduleId && { productionScheduleId: ps.productionScheduleId }),
            tenderMaterialId: material.tenderMaterialId || material.lineNo,
            plannedStartDate: ps.plannedStartDate ? dayjs(ps.plannedStartDate).format("YYYY-MM-DD") : "",
            plannedEndDate: ps.plannedStartDate && ps.productionLeadDays
              ? dayjs(ps.plannedStartDate).add(ps.productionLeadDays, "day").format("YYYY-MM-DD")
              : ps.plannedEndDate ? dayjs(ps.plannedEndDate).format("YYYY-MM-DD") : "",
            productionQuantity: ps.productionQuantity,
            leadDays: ps.productionLeadDays,
          })) || [];
          // Detect deleted production schedules
          const origProdIds = (origMat?.productionSchedules || [])
            .map((ps: any) => ps.productionScheduleId).filter(Boolean);
          const currProdIds = new Set((material?.productionSchedules || [])
            .map((ps: any) => ps.productionScheduleId).filter(Boolean));
          const deletedProdIds = origProdIds.filter((id: number) => !currProdIds.has(id));
          if (deletedProdIds.length > 0) matPayload.deletedProductionSchedules = deletedProdIds;
          hasChanges = true;
        }

        // Compare shipment schedules
        if (JSON.stringify(material?.shipmentSchedules || []) !== JSON.stringify(origMat?.shipmentSchedules || [])) {
          matPayload.shipmentSchedules = material.shipmentSchedules?.map((ss: any) => ({
            ...(ss.shipmentScheduleId && { shipmentScheduleId: ss.shipmentScheduleId }),
            tenderMaterialId: material.tenderMaterialId || material.lineNo,
            shippingStartDate: ss.shippingDate ? dayjs(ss.shippingDate).format("YYYY-MM-DD") : "",
            shippingEndDate: ss.shippingDate && ss.shippingLeadDays
              ? dayjs(ss.shippingDate).add(ss.shippingLeadDays, "day").format("YYYY-MM-DD")
              : ss.shippingEndDate ? dayjs(ss.shippingEndDate).format("YYYY-MM-DD") : "",
            estimatedArrival: ss.shippingDate && ss.shippingLeadDays
              ? dayjs(ss.shippingDate).add(ss.shippingLeadDays, "day").format("YYYY-MM-DD")
              : ss.shippingEndDate ? dayjs(ss.shippingEndDate).format("YYYY-MM-DD") : "",
            shippingQuantity: ss.shippingQuantity,
            lagDays: ss.shippingLeadDays,
          })) || [];
          // Detect deleted shipment schedules
          const origShipIds = (origMat?.shipmentSchedules || [])
            .map((ss: any) => ss.shipmentScheduleId).filter(Boolean);
          const currShipIds = new Set((material?.shipmentSchedules || [])
            .map((ss: any) => ss.shipmentScheduleId).filter(Boolean));
          const deletedShipIds = origShipIds.filter((id: number) => !currShipIds.has(id));
          if (deletedShipIds.length > 0) matPayload.deletedShipmentSchedules = deletedShipIds;
          hasChanges = true;
        }

        if (hasChanges) materials.push(matPayload);
      }

      // Detect deleted (unlinked) materials — those that had a bidMaterialId but are now unfilled
      const deletedMaterials: number[] = [];
      for (const material of unfilledMaterials) {
        if (material.bidMaterialId) {
          deletedMaterials.push(material.bidMaterialId);
        }
      }

      // Build questionnaire answers — only include changed answers
      const questionaries: any[] = [];
      Object?.keys(questioners)?.forEach((questionerSectionId: any) => {
        const item = questioners[questionerSectionId];
        item.questions.forEach((question: any) => {
          const answer = formData[question.questionId];
          const remarks = formData[`${question.questionId}--remarks`];
          const origAnswer = question.answer;
          const origRemarks = question.remarks;
          // Skip if nothing changed
          const answerText = typeof answer === "string" ? answer : undefined;
          if (answerText === origAnswer && (remarks || "") === (origRemarks || "")) return;
          questionaries.push({
            tenderQuestionId: question.tenderQuestionId || question.questionId,
            tenderSectionId: item.tenderSectionId || 0,
            answerText,
            remarks,
          });
        });
      });

      const updateData: any = {};
      if (materials.length > 0) updateData.materials = materials;
      if (deletedMaterials.length > 0) updateData.deletedMaterials = deletedMaterials;
      if (questionaries.length > 0) updateData.questionaries = questionaries;
      if (revisionReason) updateData.revisionReason = revisionReason;

      const hasUpdateBidChanges = updateData.materials || updateData.deletedMaterials || updateData.questionaries;
      const hasDiscountChanges = materialDiscounts.length > 0;

      if (!hasUpdateBidChanges && !hasDiscountChanges) {
        Swal.fire("Info", "No changes detected to update.", "info");
        setDisableSubmit(false);
        return;
      }

      // Call updateBid for non-discount changes
      if (hasUpdateBidChanges) {
        const formDataPayload = new FormData();
        formDataPayload.append("bid", JSON.stringify(updateData));

        const res: any = await tenderApis.updateBid(supplierBidId, formDataPayload);
        const resData = res?.response?.data || res;
        if (resData?.status === false) {
          Swal.fire("Error", resData?.message || "Failed to update bid", "error");
          return;
        }
      }

      // Call applyDiscount API for discount changes
      if (hasDiscountChanges) {
        const discountRes: any = await tenderApis.applyDiscount(
          tenderId,
          supplierBidId,
          {
            materialDiscounts,
            revisionReason: revisionReason || "",
          }
        );
        const discountResData = discountRes?.response?.data || discountRes;
        if (discountResData?.status === false) {
          Swal.fire("Error", discountResData?.message || "Failed to apply discount", "error");
          return;
        }
      }

      Swal.fire(
        "Success",
        "Bid updated successfully",
        "success"
      ).then(async () => {
        if (tenderIdProp) {
          await fetchOrderDetails();
          setMode("view");
        } else {
          navigate("/home");
        }
      });
    } catch (error: any) {
      const errMsg = error?.response?.data?.message || "Something went wrong";
      Swal.fire("Error", errMsg, "error");
    } finally {
      setDisableSubmit(false);
    }
  };

  useEffect(() => {
    if (disapprovePO == false) {
      setDisableReject(false);
    }
  }, [disapprovePO]);

  const configColumns = ({
    OriginalData,
    materialData,
    mode,
  }: {
    OriginalData: any;
    materialData: any;
    mode: string;
  }) => {
    const category = OriginalData?.tenderFor || OriginalData?.category;
    const isLineLevelDeliveryAddress = OriginalData?.isLineLevelDelivery ?? false;
    const hasInstallationRequired = materialData?.some((m: any) => m.isInstallationRequired || m.pricingInfo?.installationCharges != null) ||
      OriginalData?.materials?.some((m: any) => m.isInstallationRequired);
    if (category == "Material" || category == "Materials") {
      return [
        {
          title: "S.No.",
          dataIndex: "lineNo",
          key: "lineNo",
          align: "center",
          width: 50,
          fixed: "left",
          render: (text: any, record: MaterialOrService, index: any) => {
            return (materialPageCurrent - 1) * materialPageSize + index + 1;
          },
        },
        {
          title: "Material",
          dataIndex: "materialName",
          key: "materialName",
          align: "center",
          fixed: "left",
          width: 200,
          render: (text: any, record: any, index: any) => {
            const name = text || record?.materialCode || record?.description || `Material ${index + 1}`;
            const hierarchyParts = [
              record?.unitName,
              record?.floorNo ? `Floor: ${record.floorNo}` : null,
              record?.subUnitName,
            ].filter(Boolean);
            return (
              <div>
                <span>{name}</span>
                {record?._importError && (
                  <Tooltip title={record._importError}>
                    <ExclamationCircleTwoTone
                      twoToneColor="#f5222d"
                      style={{ marginLeft: 6, cursor: "pointer" }}
                    />
                  </Tooltip>
                )}
                {hierarchyParts.length > 0 && (
                  <div style={{ fontSize: 12, color: "#1890ff", marginTop: 2 }}>
                    {hierarchyParts.join(" / ")}
                  </div>
                )}
              </div>
            );
          },
        },
        {
          title: "Usage",
          dataIndex: "usage",
          key: "usage",
          align: "center",
          width: 150,
          render: (text: any) => {
            if (!text) return "-";
            return text.length > 20 ? (
              <Tooltip title={text}>
                <span style={{ cursor: "pointer" }}>{text.substring(0, 20)}...</span>
              </Tooltip>
            ) : (
              <span>{text}</span>
            );
          },
        },
        {
          title: "Category",
          dataIndex: "categoryName",
          key: "categoryName",
          align: "center",
          render: (text: any, record: MaterialOrService, index: any) => {
            return text;
          },
        },
        {
          title: ["New Tender", "Not Interested"].includes(OriginalData?.supplierBidStatus)
            ? "Quantity"
            : "Requested Quantity",
          dataIndex: "quantity",
          key: "quantity",
          align: "center",
          width: 150,
          render: (text: any, record: any) => (
            <div className="justify-end">
              {Number(text).toFixed(2)} {record?.uomName || record?.uom || ""}
            </div>
          ),
        },
        {
          title: "Supply Quantity",
          key: "supplyQuantity",
          align: "center",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          width: 150,
          render: (text: any, record: MaterialOrService) => {
            const { pricingInfo } = record;
            const {
              isUnitPriceNegotiable,
              unitPrice,
              taxType,
              taxPercentage,
              supplyQuantity,
            } = pricingInfo || {};

            const initialData: any = {
              needByDate:
                dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
              deliveryAddress: record?.deliveryAddress || "",
              quantity: record?.quantity || undefined,
              supplierQuantity: supplyQuantity || undefined,
              supplierUnitPrice:
                pricingInfo?.unitPrice || record?.unitPrice || undefined,
              isUnitPriceNegotiable: pricingInfo?.isUnitPriceNegotiable || "Yes",
              unitPrice: record?.unitPrice || undefined,
              installationCharges: pricingInfo?.installationCharges || undefined,
              discount: pricingInfo?.discount || undefined,
            };
            if (taxType) initialData.taxType = taxType;
            if (taxPercentage) initialData.taxPercentage = taxPercentage;

            // if(!OriginalData?.negotiable)mode="view"
            return (
              <PricingInfoCellHOF
                colKey="supplyQuantity"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {!supplyQuantity && mode == "edit" ? (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(mode == "edit");
                        setPopupCol("supplyQuantity");
                      }}
                    >
                      Update Quantity
                    </div>
                  ) : (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(false);
                        setPopupCol("supplyQuantity");
                      }}
                    >
                      {supplyQuantity ? (
                        <>
                          {Number(supplyQuantity).toFixed(2)} {record?.uomName || record?.uom || ""}
                        </>
                      ) : (
                        <>N/A</>
                      )}
                    </div>
                  )}
                </div>
              </PricingInfoCellHOF>
            );
          },
        },
        // {
        //   title: "Price",
        //   key: "unitPrice",
        //   align: "center",

        //   render: (text: any, record: any) => {
        //     const price =
        //       record?.unitPrice ??
        //       record?.pricingInfo?.unitPrice ??
        //       record?.bidResponse?.unitPrice;
        //     return (
        //       <div className="justify-end">
        //         {price
        //           ? formatCurrency(Number(price).toFixed(2), "INR")
        //           : "-"}
        //       </div>
        //     );
        //   },
        // },
        {
          title: "Supplier Unit Price",
          key: "supplierUnitPrice",
          align: "center",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          width: 200,
          render: (text: any, record: MaterialOrService) => {
            const { pricingInfo } = record;
            const {
              isUnitPriceNegotiable,
              unitPrice,
              taxType,
              taxPercentage,
              supplyQuantity,
            } = pricingInfo || {};

            const initialData: any = {
              needByDate:
                dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
              deliveryAddress: record?.deliveryAddress || "",
              quantity: record?.quantity || undefined,
              supplierQuantity: supplyQuantity || undefined,
              supplierUnitPrice:
                pricingInfo?.unitPrice || record?.unitPrice || undefined,
              isUnitPriceNegotiable: pricingInfo?.isUnitPriceNegotiable || "Yes",
              unitPrice: record?.unitPrice || undefined,
              installationCharges: pricingInfo?.installationCharges || undefined,
              discount: pricingInfo?.discount || undefined,
            };
            if (taxType) initialData.taxType = taxType;
            if (taxPercentage) initialData.taxPercentage = taxPercentage;

            return (
              <PricingInfoCellHOF
                colKey="supplierUnitPrice"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {!unitPrice && mode == "edit" ? (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(mode == "edit");
                        setPopupCol("supplierUnitPrice");
                      }}
                    >
                      Update Price
                    </div>
                  ) : (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(false);
                        setPopupCol("supplierUnitPrice");
                      }}
                    >
                      {unitPrice
                        ? formatCurrency(Number(unitPrice).toFixed(2), "INR")
                        : "N/A"}
                    </div>
                  )}
                </div>
              </PricingInfoCellHOF>
            );
          },
        },
        {
          title: "Installation Charges",
          key: "installationCharges",
          align: "center",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          width: 180,
          render: (text: any, record: MaterialOrService) => {
            const installationCharges = record?.pricingInfo?.installationCharges;
            if (!record?.isInstallationRequired && installationCharges == null) {
              return <div className="justify-end">-</div>;
            }
            return (
              <div className="justify-end">
                {installationCharges != null
                  ? formatCurrency(Number(installationCharges).toFixed(2), "INR")
                  : "N/A"}
              </div>
            );
          },
        },
        {
          title: "Discount (%)",
          key: "discount",
          align: "center",
          hidden: OriginalData?.status !== "Evaluated",
          width: 150,
          render: (text: any, record: MaterialOrService) => {
            const { pricingInfo } = record;
            const {
              isUnitPriceNegotiable,
              unitPrice,
              taxType,
              taxPercentage,
              supplyQuantity,
            } = pricingInfo || {};

            const initialData: any = {
              needByDate:
                dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
              deliveryAddress: record?.deliveryAddress || "",
              quantity: record?.quantity || undefined,
              supplierQuantity: supplyQuantity || undefined,
              supplierUnitPrice:
                pricingInfo?.unitPrice || record?.unitPrice || undefined,
              isUnitPriceNegotiable: pricingInfo?.isUnitPriceNegotiable || "Yes",
              unitPrice: record?.unitPrice || undefined,
              installationCharges: pricingInfo?.installationCharges || undefined,
              discount: pricingInfo?.discount || undefined,
            };
            if (taxType) initialData.taxType = taxType;
            if (taxPercentage) initialData.taxPercentage = taxPercentage;

            return (
              <PricingInfoCellHOF
                colKey="discount"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {!pricingInfo?.discount && pricingInfo?.discount !== 0 && mode == "edit" ? (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(mode == "edit");
                        setPopupCol("discount");
                      }}
                    >
                      Update Discount
                    </div>
                  ) : (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(false);
                        setPopupCol("discount");
                      }}
                    >
                      {pricingInfo?.discount != null
                        ? `${Number(pricingInfo.discount)}%`
                        : "N/A"}
                    </div>
                  )}
                </div>
              </PricingInfoCellHOF>
            );
          },
        },
        {
          title: "Need By Date",
          key: "needByDate",
          width: 150,
          align: "center",

          render: (text: any, record: any) => {
            const date =
              record?.needByDate || OriginalData?.lastSubmissionDate;
            return date ? dayjs(date).format("DD-MMM-YYYY") : "-";
          },
        },
        {
          title: "Planning Schedule",
          dataIndex: "planningSchedules",
          key: "planningSchedules",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),

          width: 150,
          render: (text: any, record: MaterialOrService) => {
            const { planningSchedules } = record;
            const { startDate, endDate, plannedLeadDays } =
              planningSchedules || {};

            const initialData: any = {};
            if (startDate) initialData.startDate = startDate;
            if (endDate) initialData.endDate = endDate;
            if (plannedLeadDays) initialData.plannedLeadDays = plannedLeadDays;

            return (
              <PlanningSchedulesCellHOF
                colKey="planningSchedules"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {(!startDate || !plannedLeadDays) && mode == "edit" ? (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        if (openPlanningSchedulePopUp === record?.lineNo) return;
                        setOpenPlanningSchedulePopUp(record?.lineNo);
                        setEditPlanningSchedule(mode == "edit");
                        setPopupCol("planningSchedules");
                      }}
                    >
                      Schedule Planning
                    </div>
                  ) : (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        if (openPlanningSchedulePopUp === record?.lineNo) return;
                        setOpenPlanningSchedulePopUp(record?.lineNo);
                        setEditPlanningSchedule(false);
                        setPopupCol("planningSchedules");
                      }}
                    >
                      View Schedule
                    </div>
                  )}
                </div>
              </PlanningSchedulesCellHOF>
            );
          },
        },
        {
          title: "Production Schedule",
          dataIndex: "productionSchedules",
          key: "productionSchedules",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),

          width: 150,
          render: (text: any, record: MaterialOrService) => {
            const { productionSchedules } = record;

            const initialData: any = productionSchedules?.map(
              (productionSchedule) => {
                const {
                  productionQuantity,
                  plannedStartDate,
                  productionLeadDays,
                  plannedEndDate,
                  key,
                } = productionSchedule || {};
                const data: any = { key };
                if (productionQuantity)
                  data.productionQuantity = productionQuantity;
                if (plannedStartDate) data.plannedStartDate = plannedStartDate;
                if (productionLeadDays)
                  data.productionLeadDays = productionLeadDays;
                if (plannedEndDate) data.plannedEndDate = plannedEndDate;
                return data;
              }
            );

            return (
              <ProductionSchedulesCellHOF
                colKey="productionSchedules"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {initialData?.length >= 1 ? (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        if (openProductionSchedulesPopUp === record?.lineNo) return;
                        setOpenProductionSchedulesPopUp(record?.lineNo);
                        setEditProductionSchedules(false);
                        setPopupCol("productionSchedules");
                      }}
                    >
                      View Schedule
                    </div>
                  ) : (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        if (openProductionSchedulesPopUp === record?.lineNo) return;
                        setOpenProductionSchedulesPopUp(record?.lineNo);
                        setEditProductionSchedules(mode == "edit");
                        setPopupCol("productionSchedules");
                      }}
                    >
                      Schedule Production
                    </div>
                  )}
                </div>
              </ProductionSchedulesCellHOF>
            );
          },
        },
        {
          title: "Shipment Schedule",
          dataIndex: "shipmentSchedules",
          key: "shipmentSchedules",
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          width: 150,
          render: (text: any, record: MaterialOrService) => {
            const { shipmentSchedules } = record;

            const initialData: any = shipmentSchedules?.map(
              (shipmentSchedule) => {
                const {
                  shippingQuantity,
                  shippingDate,
                  shippingLeadDays,
                  shippingEndDate,
                  key,
                } = shipmentSchedule || {};
                const data: any = { key };
                if (shippingQuantity) data.shippingQuantity = shippingQuantity;
                if (shippingDate) data.shippingDate = shippingDate;
                if (shippingLeadDays) data.shippingLeadDays = shippingLeadDays;
                if (shippingEndDate) data.shippingEndDate = shippingEndDate;
                return data;
              }
            );

            return (
              <ShippingSchedulesCellHOF
                colKey="shipmentSchedules"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="d-flex justify-content-between w-100">
                  {initialData?.length >= 1 ? (
                    <div
                      style={{ color: "#28A745" }}
                      className="justify-end w-100"
                      onClick={() => {
                        if (openShipmentSchedulesPopUp === record?.lineNo) return;
                        setOpenShipmentSchedulesPopUp(record?.lineNo);
                        setEditShipmentSchedules(false);
                        setPopupCol("shipmentSchedules");
                      }}
                    >
                      View Schedule
                    </div>
                  ) : (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        if (openShipmentSchedulesPopUp === record?.lineNo) return;
                        setOpenShipmentSchedulesPopUp(record?.lineNo);
                        setEditShipmentSchedules(mode == "edit");
                        setPopupCol("shipmentSchedules");
                      }}
                    >
                      Schedule Shipment
                    </div>
                  )}
                </div>
              </ShippingSchedulesCellHOF>
            );
          },
        },
        {
          title: "Sub Total",
          key: "subTotal",
          align: "center",
          width: 150,
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          render: (text: any, record: any) => {
            const price =
              record?.pricingInfo?.unitPrice ?? record?.unitPrice ?? 0;
            const qty =
              record?.pricingInfo?.supplyQuantity ?? record?.quantity ?? 0;
            const discountPct = Number(record?.pricingInfo?.discount || 0);
            const lineTotal = Number(qty) * Number(price);
            const subTotal = lineTotal - (lineTotal * discountPct) / 100;
            return (
              <div className="justify-end">
                {formatCurrency(subTotal.toFixed(2), "INR")}
              </div>
            );
          },
        },
        {
          title: "Total Installation Charges",
          key: "totalInstallationCharges",
          align: "center",
          width: 200,
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          render: (text: any, record: any) => {
            const installation = Number(record?.pricingInfo?.installationCharges || 0);
            if (!record?.isInstallationRequired && !installation) {
              return <div className="justify-end">-</div>;
            }
            const qty =
              record?.pricingInfo?.supplyQuantity ?? record?.quantity ?? 0;
            const totalInstallation = Number(qty) * installation;
            return (
              <div className="justify-end">
                {formatCurrency(totalInstallation.toFixed(2), "INR")}
              </div>
            );
          },
        },
        {
          title: "Taxable Amount",
          key: "taxableAmount",
          align: "center",
          width: 150,
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          render: (text: any, record: any) => {
            const price =
              record?.pricingInfo?.unitPrice ?? record?.unitPrice ?? 0;
            const qty =
              record?.pricingInfo?.supplyQuantity ?? record?.quantity ?? 0;
            const installation = Number(record?.pricingInfo?.installationCharges || 0);
            const discountPct = Number(record?.pricingInfo?.discount || 0);
            const lineTotal = Number(qty) * Number(price);
            const discountedTotal = lineTotal - (lineTotal * discountPct) / 100;
            const totalInstallation = Number(qty) * installation;
            const taxable = discountedTotal + totalInstallation;
            return (
              <div className="justify-end">
                {formatCurrency(taxable.toFixed(2), "INR")}
              </div>
            );
          },
        },
        {
          title: "Tax",
          key: "taxPercentage",
          align: "center",
          width: 180,
          hidden: ["New Tender", "Not Interested"].includes(
            OriginalData?.supplierBidStatus
          ),
          render: (text: any, record: any) => {
            const { pricingInfo } = record;
            const {
              isUnitPriceNegotiable,
              unitPrice,
              taxType,
              taxPercentage,
              supplyQuantity,
            } = pricingInfo || {};

            const initialData: any = {
              needByDate:
                dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
              deliveryAddress: record?.deliveryAddress || "",
              quantity: record?.quantity || undefined,
              supplierQuantity: supplyQuantity || undefined,
              supplierUnitPrice:
                pricingInfo?.unitPrice || record?.unitPrice || undefined,
              isUnitPriceNegotiable: pricingInfo?.isUnitPriceNegotiable || "Yes",
              unitPrice: record?.unitPrice || undefined,
              installationCharges: pricingInfo?.installationCharges || undefined,
              discount: pricingInfo?.discount || undefined,
            };
            if (taxType) initialData.taxType = taxType;
            if (taxPercentage) initialData.taxPercentage = taxPercentage;

            const price = pricingInfo?.unitPrice ?? record?.unitPrice ?? 0;
            const qty = supplyQuantity ?? record?.quantity ?? 0;
            const installation = Number(pricingInfo?.installationCharges || 0);
            const discountPct = Number(pricingInfo?.discount || 0);
            const taxPct = Number(taxPercentage || 0);
            const lineTotal = Number(qty) * Number(price);
            const discountedTotal = lineTotal - (lineTotal * discountPct) / 100;
            const totalInstallation = Number(qty) * installation;
            const taxable = discountedTotal + totalInstallation;
            const taxAmount = (taxable * taxPct) / 100;

            return (
              <PricingInfoCellHOF
                colKey="taxPercentage"
                lineNo={record?.lineNo}
                initialData={initialData}
                mode={mode}
              >
                <div className="w-100">
                  {(!taxType || !taxPercentage) && mode == "edit" ? (
                    <div
                      className="w-100"
                      style={{
                        cursor: "pointer",
                        color: "#0378fc",
                        fontStyle: "italic",
                      }}
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(mode == "edit");
                        setPopupCol("taxPercentage");
                      }}
                    >
                      Update Tax
                    </div>
                  ) : (
                    <div
                      style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
                      className="w-100"
                      onClick={() => {
                        setOpenPricingInfoPopUp(record?.lineNo);
                        setEditPriceInfo(false);
                        setPopupCol("taxPercentage");
                      }}
                    >
                      {taxType && taxPercentage ? (
                        <>
                          <span style={{ color: "#28A745", fontWeight: 500 }}>
                            {taxType}: {Number(taxPercentage)}%
                          </span>
                          <span style={{ color: "#999" }}>|</span>
                          <span style={{ color: "#555" }}>
                            {formatCurrency(taxAmount.toFixed(2), "INR")}
                          </span>
                        </>
                      ) : (
                        <span style={{ color: "#28A745" }}>N/A</span>
                      )}
                    </div>
                  )}
                </div>
              </PricingInfoCellHOF>
            );
          },
        },
        {
          title: "Total",
          key: "total",
          align: "center",

          render: (text: any, record: any) => {
            const price =
              record?.pricingInfo?.unitPrice ??
              record?.unitPrice ??
              record?.bidResponse?.unitPrice ?? 0;
            const qty =
              record?.pricingInfo?.supplyQuantity ?? record?.quantity ?? 0;
            const installation = Number(record?.pricingInfo?.installationCharges || 0);
            const discountPct = Number(record?.pricingInfo?.discount || 0);
            const taxPct = Number(record?.pricingInfo?.taxPercentage || 0);
            const lineTotal = Number(qty) * Number(price);
            const discountedTotal = lineTotal - (lineTotal * discountPct) / 100;
            const totalInstallation = Number(qty) * installation;
            const taxable = discountedTotal + totalInstallation;
            const taxAmount = (taxable * taxPct) / 100;
            const total = taxable + taxAmount;
            return (
              <div className="justify-end">
                {formatCurrency(total.toFixed(2), "INR")}
              </div>
            );
          },
        },
      ];
    }
    return [
      {
        title: "S.No.",
        dataIndex: "lineNo",
        key: "lineNo",
        align: "center",
        width: 50,
        fixed: "left",
        render: (text: any, record: MaterialOrService, index: any) => {
          return (materialPageCurrent - 1) * materialPageSize + index + 1;
        },
      },
      {
        title: "Category",
        dataIndex: "categoryName",
        key: "categoryName",
        align: "center",
        render: (text: any, record: MaterialOrService, index: any) => {
          return text;
        },
      },
      {
        title: "Sub Category",
        dataIndex: "subCategory",
        key: "subCategory",
        align: "center",
        fixed: "left",
        width: 200,
        render: (text: any, record: MaterialOrService, index: any) => {
          return text;
        },
      },
      {
        title: "Work Line",
        dataIndex: "workLineName",
        key: "workLineName",
        align: "center",
        fixed: "left",
        width: 200,
        render: (text: any, record: MaterialOrService, index: any) => {
          return text;
        },
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        align: "center",
        width: 150,
        render: (text: any, record: MaterialOrService) => (
          <div className="justify-end">
            {Number(text).toFixed(2)} {record?.uomName || record?.uom || ""}
          </div>
        ),
      },
      // {
      //   title: "Price",
      //   dataIndex: "unitPrice",
      //   key: "unitPrice",
      //   align: "center",

      //   render: (text: any, record: MaterialOrService) => {
      //     return (
      //       <div className="justify-end">
      //         {formatCurrency(Number(text).toFixed(2), "INR")}
      //       </div>
      //     );
      //   },
      // },
      {
        title: "Supplier Price",
        key: "supplierUnitPrice",
        align: "center",
        hidden: ["New Tender", "Not Interested"].includes(OriginalData?.supplierBidStatus),
        render: (text: any, record: MaterialOrService) => {
          const { pricingInfo } = record;
          const { taxType, taxPercentage, workingDays, unitPrice } =
            pricingInfo || {};

          const initialData: any = {
            needByDate:
              dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
            deliveryAddress: record?.deliveryAddress || "",
            supplierUnitPrice: unitPrice || record?.unitPrice || undefined,
            unitPrice: record?.unitPrice || undefined,
            workingDays: workingDays || undefined,
          };
          if (taxType) initialData.taxType = taxType;
          if (taxPercentage) initialData.taxPercentage = taxPercentage;

          return (
            <ServicePricingInfoCellHOF
              colKey="serviceUnitPricePricingInfo"
              lineNo={record?.lineNo}
              initialData={initialData}
              mode={mode}
            >
              <div className="d-flex justify-content-between w-100">
                {!unitPrice && mode == "edit" ? (
                  <div
                    className="w-100"
                    style={{
                      cursor: "pointer",
                      color: "#0378fc",
                      fontStyle: "italic",
                    }}
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(mode == "edit");

                      setPopupCol("serviceUnitPricePricingInfo");
                    }}
                  >
                    Update Pricing
                  </div>
                ) : (
                  <div
                    style={{ color: "#28A745" }}
                    className="justify-end w-100"
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(false);
                      setPopupCol("serviceUnitPricePricingInfo");
                    }}
                  >
                    {unitPrice
                      ? formatCurrency(Number(unitPrice).toFixed(2), "INR")
                      : "N/A"}
                  </div>
                )}
              </div>
            </ServicePricingInfoCellHOF>
          );
        },
      },
      {
        title: "Working Days",
        key: "workingDays",
        align: "center",
        hidden: ["New Tender", "Not Interested"].includes(OriginalData?.supplierBidStatus),

        render: (text: any, record: MaterialOrService) => {
          const { pricingInfo } = record;
          const { taxType, taxPercentage, workingDays, unitPrice } =
            pricingInfo || {};

          const initialData: any = {
            needByDate:
              dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
            deliveryAddress: record?.deliveryAddress || "",
            supplierUnitPrice: unitPrice || record?.unitPrice || undefined,
            unitPrice: record?.unitPrice || undefined,
            workingDays: workingDays || undefined,
          };
          if (taxType) initialData.taxType = taxType;
          if (taxPercentage) initialData.taxPercentage = taxPercentage;

          return (
            <ServicePricingInfoCellHOF
              colKey="serviceWorkingDaysPricingInfo"
              lineNo={record?.lineNo}
              initialData={initialData}
              mode={mode}
            >
              <div className="d-flex justify-content-between w-100">
                {!workingDays && mode == "edit" ? (
                  <div
                    className="w-100"
                    style={{
                      cursor: "pointer",
                      color: "#0378fc",
                      fontStyle: "italic",
                    }}
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(mode == "edit");
                      setPopupCol("serviceWorkingDaysPricingInfo");
                    }}
                  >
                    Add Working Days
                  </div>
                ) : (
                  <div
                    style={{ color: "#28A745" }}
                    className="justify-end w-100"
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(false);
                      setPopupCol("serviceWorkingDaysPricingInfo");
                    }}
                  >
                    {workingDays || "0"} days
                  </div>
                )}
              </div>
            </ServicePricingInfoCellHOF>
          );
        },
      },
      {
        title: "Tax %",
        key: "taxPercentage",
        align: "center",
        hidden: ["New Tender", "Not Interested"].includes(OriginalData?.supplierBidStatus),
        render: (text: any, record: MaterialOrService) => {
          const { pricingInfo } = record;
          const { taxType, taxPercentage, workingDays } = pricingInfo || {};

          const initialData: any = {
            needByDate:
              dayjs(record?.needByDate)?.format("YYYY-MM-DD") || undefined,
            deliveryAddress: record?.deliveryAddress || "",
            supplierUnitPrice:
              pricingInfo?.unitPrice || record?.unitPrice || undefined,
            unitPrice: record?.unitPrice || undefined,
            workingDays: workingDays || undefined,
          };
          if (taxType) initialData.taxType = taxType;
          if (taxPercentage) initialData.taxPercentage = taxPercentage;

          return (
            <ServicePricingInfoCellHOF
              colKey="serviceTaxPricingInfo"
              lineNo={record?.lineNo}
              initialData={initialData}
              mode={mode}
            >
              <div className="d-flex justify-content-between w-100">
                {(!taxType || !taxPercentage) && mode == "edit" ? (
                  <div
                    className="w-100"
                    style={{
                      cursor: "pointer",
                      color: "#0378fc",
                      fontStyle: "italic",
                    }}
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(mode == "edit");
                      setPopupCol("serviceTaxPricingInfo");
                    }}
                  >
                    Update Tax
                  </div>
                ) : (
                  <div
                    style={{ color: "#28A745" }}
                    className="justify-end w-100"
                    onClick={() => {
                      setOpenServicePricingInfoPopUp(record?.lineNo);
                      setEditServicePriceInfo(false);
                      setPopupCol("serviceTaxPricingInfo");
                    }}
                  >
                    {taxType && taxPercentage ? (
                      <>
                        {taxType}: {Number(taxPercentage)}%
                      </>
                    ) : (
                      <>N/A</>
                    )}
                  </div>
                )}
              </div>
            </ServicePricingInfoCellHOF>
          );
        },
      },
      {
        title: "Total",
        key: "total",
        align: "center",

        render: (text: any, record: any) => {
          const price =
            record?.unitPrice ??
            record?.pricingInfo?.unitPrice ??
            record?.bidResponse?.unitPrice;
          const qty = record?.quantity;
          const total =
            price != null && qty != null
              ? Number(qty) * Number(price)
              : NaN;
          return (
            <div className="justify-end">
              {isNaN(total) ? "-" : formatCurrency(total.toFixed(2), "INR")}
            </div>
          );
        },
      },
    ];
  };

  const PricingInfoForm = ({
    lineNo,
    initialData,
    allowEdit,
    mode,
    setMaterialData,
  }: {
    lineNo: number;
    initialData?: any;
    allowEdit?: boolean;
    mode?: string;
    setMaterialData: any;
  }) => {
    const [alertStatus, setAlertStatus] = useState<{
      open: boolean;
      message: string;
      type: "success" | "danger";
    }>({
      open: false,
      message: "",
      type: "success",
    });
    const methods = useForm({
      mode: "onChange",
    });

    const {
      handleSubmit,
      reset,
      watch,
      setValue,
      formState: { errors },
    } = methods;
    useEffect(() => {
      reset({
        ...initialData,
      });
    }, [initialData]);
    const isUnitPriceNegotiable = watch("isUnitPriceNegotiable");
    const quantity = watch("quantity");
    useEffect(() => {
      if (isUnitPriceNegotiable == "No") {
        setValue("supplierUnitPrice", initialData?.unitPrice);
      }
    }, [isUnitPriceNegotiable]);
    return (
      <>
        <FormProvider {...methods}>
          <form className="content clearfix mt-2 ps-1">
            <div className="row g-3">
              <div className="col-6">
                <FormInput
                  name="needByDate"
                  label={undefined}
                  optionLabel="Need By Date: "
                  optionLabelWidth={"120px"}
                  disabled
                  unMaskView={true}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="deliveryAddress"
                  label={undefined}
                  optionLabel="Delivery Address"
                  optionLabelWidth={"120px"}
                  disabled
                  unMaskView={true}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormInput
                  name="quantity"
                  label={undefined}
                  optionLabel="Asked Quantity: "
                  optionLabelWidth={"120px"}
                  placeholder="100"
                  disabled
                  unMaskView={true}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="supplierQuantity"
                  label={undefined}
                  required={true}
                  optionLabel="Supplier Quantity"
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Update Quantity" : "N/A"}
                  min={0}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormSelect
                  name="taxType"
                  label={undefined}
                  required={true}
                  optionLabel="Tax Type: "
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Select Tax Type" : "N/A"}
                  options={[
                    { label: "GST", value: "GST" },
                    { label: "VAT", value: "VAT" },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              <div className="col-6">
                <FormSelect
                  name="taxPercentage"
                  label={undefined}
                  required={true}
                  optionLabel="Tax %"
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Select Tax %" : "N/A"}
                  options={[
                    { label: "0%", value: 0 },
                    { label: "1%", value: 1 },
                    { label: "5%", value: 5 },
                    { label: "12%", value: 12 },
                    { label: "15%", value: 15 },
                    { label: "18%", value: 18 },
                    { label: "28%", value: 28 },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormSelect
                  name="isUnitPriceNegotiable"
                  required={true}
                  label={undefined}
                  optionLabel="Change Price"
                  optionLabelWidth={"120px"}
                  placeholder="Is Unit Price Negotiable ?"
                  options={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="supplierUnitPrice"
                  label={undefined}
                  required={mode == "edit" && isUnitPriceNegotiable == "Yes"}
                  optionLabel="Unit Price: "
                  optionLabelWidth={"120px"}
                  placeholder="0"
                  disabled={mode == "view" || isUnitPriceNegotiable == "No"}
                  unMaskView={mode == "view"}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="installationCharges"
                  label={undefined}
                  optionLabel="Installation Charges: "
                  optionLabelWidth={"120px"}
                  placeholder="0"
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              {OriginalData?.status === "Evaluated" && (
              <div className="col-6">
                <FormInput
                  name="discount"
                  label={undefined}
                  optionLabel="Discount (%): "
                  optionLabelWidth={"120px"}
                  placeholder="0"
                  min={0}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              )}
            </div>
          </form>
        </FormProvider>
        <Alert
          color={alertStatus.type}
          isOpen={alertStatus.open}
          className="start-0 w-100 py-1 mt-1"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <ReactTyped
            strings={[alertStatus.message]}
            typeSpeed={5}
            showCursor={false}
          />
        </Alert>
        <div className="actions clearfix">
          {mode == "view" && (
            <ul>
              {allowEdit && (
                <li>
                  <Button
                    color="primary"
                    size="sm"
                    type="button"
                    onClick={() => setEditPriceInfo(true)}
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Button>
                </li>
              )}
              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPriceInfo(false);
                    setOpenPricingInfoPopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
          {mode == "edit" && (
            <ul>
              <li>
                <Button
                  color="primary"
                  size="sm"
                  type="button"
                  onClick={handleSubmit(async (data) => {
                    try {
                      setAlertStatus({
                        open: false,
                        message: "",
                        type: "success",
                      });
                      const {
                        //   deliveryAddress,
                        isUnitPriceNegotiable,
                        //   needByDate,
                        quantity,
                        supplierQuantity,
                        supplierUnitPrice,
                        taxPercentage,
                        taxType,
                        installationCharges,
                        discount,
                        //   unitPrice,
                      } = data;
                      if (supplierQuantity <= 0) {
                        setAlertStatus({
                          open: true,
                          message: "Supplier Quantity should be greater than 0",
                          type: "danger",
                        });
                      } else if (supplierQuantity > quantity) {
                        setAlertStatus({
                          open: true,
                          message:
                            "Supplier Quantity should be less than or equal to Quantity",
                          type: "danger",
                        });
                      } else if (!taxType) {
                        setAlertStatus({
                          open: true,
                          message: "Tax Type is required",
                          type: "danger",
                        });
                      } else if (!taxPercentage) {
                        setAlertStatus({
                          open: true,
                          message: "Tax Percentage is required",
                          type: "danger",
                        });
                      } else if (
                        isUnitPriceNegotiable == "Yes" &&
                        (!supplierUnitPrice || supplierUnitPrice <= 0)
                      ) {
                        setAlertStatus({
                          open: true,
                          message: "Unit Price is required",
                          type: "danger",
                        });
                      }
                      // Call applyDiscount API if discount changed and status is Evaluated
                      const currentMaterial = materialData?.find((m: any) => m.lineNo == lineNo);
                      const oldDiscount = Number(currentMaterial?.pricingInfo?.discount || 0);
                      const newDiscount = discount ? +discount : 0;
                      if (
                        OriginalData?.status === "Evaluated" &&
                        newDiscount !== oldDiscount &&
                        currentMaterial?.bidMaterialId
                      ) {
                        const supplierBidId = currentBidId ||
                          OriginalData?.bidDetails?.supplierBidId ||
                          OriginalData?.bidsSummary?.[0]?.bidId;
                        if (supplierBidId) {
                          const { value: revisionReason } = await Swal.fire({
                            title: "Revision Reason",
                            input: "textarea",
                            inputLabel: "Please provide a reason for the discount change",
                            inputPlaceholder: "Enter revision reason...",
                            showCancelButton: true,
                            confirmButtonText: "Apply Discount",
                          });
                          if (revisionReason === undefined) return; // cancelled
                          try {
                            await tenderApis.applyDiscount(tenderId, supplierBidId, {
                              materialDiscounts: [{
                                bidMaterialId: currentMaterial.bidMaterialId,
                                discountPercent: newDiscount,
                              }],
                              revisionReason: revisionReason || "",
                            });
                          } catch (err: any) {
                            Swal.fire("Error", err?.response?.data?.message || "Failed to apply discount", "error");
                            return;
                          }
                        }
                      }

                      setMaterialData((materials: MaterialOrService[]) => {
                        return materials.map((material: any) => {
                          if (material?.lineNo == lineNo) {
                            return {
                              ...material,
                              _importError: null,
                              pricingInfo: {
                                ...material.pricingInfo,
                                supplyQuantity: +supplierQuantity,
                                isUnitPriceNegotiable,
                                unitPrice: +supplierUnitPrice,
                                taxPercentage,
                                taxType,
                                installationCharges: installationCharges ? +installationCharges : 0,
                                discount: discount ? +discount : 0,
                              },
                            };
                          } else return material;
                        });
                      });

                      setEditPriceInfo(false);
                      setOpenPricingInfoPopUp(null);
                      setPopupCol("");
                    } catch (error) {
                      console.log(error);
                    }
                  })}
                >
                  <Icon name="save" />
                  <span>Save</span>
                </Button>
              </li>

              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPriceInfo(false);
                    setOpenPricingInfoPopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
        </div>
      </>
    );
  };

  const ServicePricingInfoForm = ({
    lineNo,
    initialData,
    allowEdit,
    mode,
    setMaterialData,
  }: {
    lineNo: number;
    initialData?: any;
    allowEdit?: boolean;
    mode?: string;
    setMaterialData: any;
  }) => {
    const [alertStatus, setAlertStatus] = useState<{
      open: boolean;
      message: string;
      type: "success" | "danger";
    }>({
      open: false,
      message: "",
      type: "success",
    });
    const methods = useForm({
      mode: "onChange",
    });

    const {
      handleSubmit,
      reset,
      watch,
      setValue,
      formState: { errors },
    } = methods;
    useEffect(() => {
      reset({
        ...initialData,
      });
    }, [initialData]);
    return (
      <>
        <FormProvider {...methods}>
          <form className="content clearfix mt-2 ps-1">
            <div className="row g-3">
              <div className="col-6">
                <FormSelect
                  name="taxType"
                  label={undefined}
                  required={true}
                  optionLabel="Tax Type: "
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Select Tax Type" : "N/A"}
                  options={[
                    { label: "GST", value: "GST" },
                    { label: "VAT", value: "VAT" },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              <div className="col-6">
                <FormSelect
                  name="taxPercentage"
                  label={undefined}
                  required={true}
                  optionLabel="Tax %"
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Select Tax %" : "N/A"}
                  options={[
                    { label: "0%", value: 0 },
                    { label: "1%", value: 1 },
                    { label: "5%", value: 5 },
                    { label: "12%", value: 12 },
                    { label: "15%", value: 15 },
                    { label: "18%", value: 18 },
                    { label: "28%", value: 28 },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormInput
                  name="unitPrice"
                  label={undefined}
                  required={mode == "edit"}
                  optionLabel="Actual Price: "
                  optionLabelWidth={"120px"}
                  placeholder="130"
                  disabled={true}
                  unMaskView={true}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="supplierUnitPrice"
                  label={undefined}
                  required={mode == "edit"}
                  optionLabel="Your Price: "
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Update Your Price" : "N/A"}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormInput
                  name="workingDays"
                  label={undefined}
                  optionLabel="Working Days"
                  optionLabelWidth={"120px"}
                  placeholder={mode == "edit" ? "Enter Working Days" : "N/A"}
                  required={mode == "edit"}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
          </form>
        </FormProvider>
        <Alert
          color={alertStatus.type}
          isOpen={alertStatus.open}
          className="start-0 w-100 py-1 mt-1"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <ReactTyped
            strings={[alertStatus.message]}
            typeSpeed={5}
            showCursor={false}
          />
        </Alert>
        <div className="actions clearfix">
          {mode == "view" && (
            <ul>
              {allowEdit && (
                <li>
                  <Button
                    color="primary"
                    size="sm"
                    type="button"
                    onClick={() => setEditPriceInfo(true)}
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Button>
                </li>
              )}
              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPriceInfo(false);
                    setOpenPricingInfoPopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
          {mode == "edit" && (
            <ul>
              <li>
                <Button
                  color="primary"
                  size="sm"
                  type="button"
                  onClick={handleSubmit((data) => {
                    try {
                      setAlertStatus({
                        open: false,
                        message: "",
                        type: "success",
                      });
                      const {
                        supplierUnitPrice,
                        taxPercentage,
                        taxType,
                        unitPrice,
                        workingDays,
                      } = data;
                      if (!taxType) {
                        setAlertStatus({
                          open: true,
                          message: "Tax Type is required",
                          type: "danger",
                        });
                      } else if (!taxPercentage) {
                        setAlertStatus({
                          open: true,
                          message: "Tax Percentage is required",
                          type: "danger",
                        });
                      } else if (!supplierUnitPrice || supplierUnitPrice <= 0) {
                        setAlertStatus({
                          open: true,
                          message: "Unit Price is required",
                          type: "danger",
                        });
                      }
                      setMaterialData((materials: MaterialOrService[]) => {
                        return materials.map((material: MaterialOrService) => {
                          if (material?.lineNo == lineNo) {
                            return {
                              ...material,
                              pricingInfo: {
                                ...material.pricingInfo,
                                unitPrice: +supplierUnitPrice,
                                workingDays: +workingDays,
                                taxPercentage,
                                taxType,
                              },
                            };
                          } else return material;
                        });
                      });

                      setEditPriceInfo(false);
                      setOpenPricingInfoPopUp(null);
                      setPopupCol("");
                    } catch (error) {
                      console.log(error);
                    }
                  })}
                >
                  <Icon name="save" />
                  <span>Save</span>
                </Button>
              </li>

              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPriceInfo(false);
                    setOpenPricingInfoPopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
        </div>
      </>
    );
  };

  const PricingInfoCellHOF: React.FC<{
    colKey: string;
    children: React.ReactNode;
    lineNo: number;
    initialData: any;
    mode: string;
  }> = ({ children, colKey, lineNo, initialData, mode }) => {
    return (
      <div
        style={{
          cursor: "pointer",
        }}
        className="customEditableCell"
      >
        <Popconfirm
          title={<h6>Pricing Info</h6>}
          icon={<></>}
          showCancel={false}
          open={openPricingInfoPopUp == lineNo && colKey == popupCol}
          okButtonProps={{
            style: {
              display: "none",
            },
          }}
          onOpenChange={(visible) => {
            if (
              editPriceInfo ||
              editPlanningSchedule ||
              editProductionSchedules ||
              editShipmentSchedules
            )
              return;
            if (visible) {
              if (
                !openPricingInfoPopUp &&
                !openPlanningSchedulePopUp &&
                !openProductionSchedulesPopUp &&
                !openShipmentSchedulesPopUp
              ) {
                setOpenPricingInfoPopUp(() => lineNo);
              }
            }
          }}
          description={
            <div
              style={{
                minWidth: "500px",
              }}
            >
              <PricingInfoForm
                lineNo={lineNo}
                initialData={initialData}
                allowEdit={mode == "edit"}
                mode={editPriceInfo ? "edit" : "view"}
                setMaterialData={setMaterialData}
              />
            </div>
          }
        >
          {children}
        </Popconfirm>
      </div>
    );
  };

  const ServicePricingInfoCellHOF: React.FC<{
    colKey: string;
    children: React.ReactNode;
    lineNo: number;
    initialData: any;
    mode: string;
  }> = ({ children, colKey, lineNo, initialData, mode }) => {
    return (
      <div
        style={{
          cursor: "pointer",
        }}
        className="customEditableCell"
      >
        <Popconfirm
          title={<h6>Pricing Info</h6>}
          icon={<></>}
          showCancel={false}
          open={openServicePricingInfoPopUp == lineNo && colKey == popupCol}
          okButtonProps={{
            style: {
              display: "none",
            },
          }}
          onOpenChange={(visible) => {
            if (
              editPriceInfo ||
              editServicePriceInfo ||
              editPlanningSchedule ||
              editProductionSchedules ||
              editShipmentSchedules
            )
              return;
            if (visible) {
              if (
                !openPricingInfoPopUp &&
                !openServicePricingInfoPopUp &&
                !openPlanningSchedulePopUp &&
                !openProductionSchedulesPopUp &&
                !openShipmentSchedulesPopUp
              ) {
                setOpenServicePricingInfoPopUp(() => lineNo);
              }
            }
          }}
          description={
            <div
              style={{
                minWidth: "500px",
              }}
            >
              <ServicePricingInfoForm
                lineNo={lineNo}
                initialData={initialData}
                allowEdit={mode == "edit"}
                mode={editPriceInfo ? "edit" : "view"}
                setMaterialData={setMaterialData}
              />
            </div>
          }
        >
          {children}
        </Popconfirm>
      </div>
    );
  };

  const PlanningScheduleForm = ({
    lineNo,
    initialData,
    allowEdit,
    mode,
    setMaterialData,
  }: {
    lineNo: number;
    initialData?: any;
    allowEdit?: boolean;
    mode?: string;
    setMaterialData: any;
  }) => {
    const [alertStatus, setAlertStatus] = useState<{
      open: boolean;
      message: string;
      type: "success" | "danger";
    }>({
      open: false,
      message: "",
      type: "success",
    });
    const methods = useForm({
      mode: "onChange",
    });

    const {
      handleSubmit,
      reset,
      watch,
      setValue,
      formState: { errors },
    } = methods;
    useEffect(() => {
      reset({
        ...initialData,
      });
    }, [initialData]);
    const startDate = watch("startDate");
    const plannedLeadDays = watch("plannedLeadDays");
    useEffect(() => {
      if (startDate && plannedLeadDays) {
        setValue("endDate", dayjs(startDate).add(+plannedLeadDays, "day"));
      }
    }, [startDate, plannedLeadDays]);
    return (
      <>
        <FormProvider {...methods}>
          <form className="content clearfix mt-2 ps-1">
            <div className="row g-3">
              <div className="col-6">
                <FormDatePicker
                  name="startDate"
                  label={undefined}
                  required
                  placeholder="Start Date"
                  minDate={dayjs().add(1, "day").toDate()}
                  optionLabel="Start Date: "
                  optionLabelWidth={"100px"}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
              <div className="col-6">
                <FormInput
                  name="plannedLeadDays"
                  label={undefined}
                  required
                  placeholder="Planned Lead Days"
                  optionLabel="Lead Days: "
                  optionLabelWidth={"100px"}
                  disabled={mode == "view"}
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-6">
                <FormDatePicker
                  name="endDate"
                  label={undefined}
                  placeholder="End Date"
                  optionLabel="End Date: "
                  optionLabelWidth={"100px"}
                  disabled
                  unMaskView={mode == "view"}
                />
              </div>
            </div>
          </form>
        </FormProvider>
        <Alert
          color={alertStatus.type}
          isOpen={alertStatus.open}
          className="start-0 w-100 py-1 mt-1"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <ReactTyped
            strings={[alertStatus.message]}
            typeSpeed={5}
            showCursor={false}
          />
        </Alert>
        <div className="actions clearfix">
          {mode == "view" && (
            <ul>
              {allowEdit && (
                <li>
                  <Button
                    color="primary"
                    size="sm"
                    type="button"
                    onClick={() => setEditPlanningSchedule(true)}
                  >
                    <Icon name="edit" />
                    <span>Edit</span>
                  </Button>
                </li>
              )}
              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPlanningSchedule(false);
                    setOpenPlanningSchedulePopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
          {mode == "edit" && (
            <ul>
              <li>
                <Button
                  color="primary"
                  size="sm"
                  type="button"
                  onClick={handleSubmit((data) => {
                    try {
                      setAlertStatus({
                        open: false,
                        message: "",
                        type: "success",
                      });
                      const { endDate, plannedLeadDays, startDate } = data;

                      setMaterialData((materials: MaterialOrService[]) => {
                        return materials.map((material: any) => {
                          if (material?.lineNo == lineNo) {
                            return {
                              ...material,
                              _importError: null,
                              planningSchedules: {
                                ...material.planningSchedules,
                                endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : endDate,
                                plannedLeadDays,
                                startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : startDate,
                              },
                            };
                          } else return material;
                        });
                      });

                      setEditPlanningSchedule(false);
                      setOpenPlanningSchedulePopUp(null);
                      setPopupCol("");
                    } catch (error) {
                      console.log(error);
                    }
                  })}
                >
                  <Icon name="save" />
                  <span>Save</span>
                </Button>
              </li>

              <li>
                <Button
                  size="sm"
                  color="primary"
                  className="btn-dim btn btn-secondary"
                  type="button"
                  onClick={() => {
                    setEditPlanningSchedule(false);
                    setOpenPlanningSchedulePopUp(null);
                    setPopupCol("");
                  }}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          )}
        </div>
      </>
    );
  };

  const PlanningSchedulesCellHOF: React.FC<{
    colKey: string;
    children: React.ReactNode;
    lineNo: number;
    initialData: any;
    mode: string;
  }> = ({ children, colKey, lineNo, initialData, mode }) => {
    return (
      <div
        style={{
          cursor: "pointer",
        }}
        className="customEditableCell"
      >
        <Popconfirm
          title={<h6>Planning Schedules</h6>}
          icon={<></>}
          showCancel={false}
          open={openPlanningSchedulePopUp == lineNo && colKey == popupCol}
          okButtonProps={{
            style: {
              display: "none",
            },
          }}
          onOpenChange={() => { }}
          description={
            <div
              style={{
                minWidth: "500px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <PlanningScheduleForm
                lineNo={lineNo}
                initialData={initialData}
                allowEdit={mode == "edit"}
                mode={editPlanningSchedule ? "edit" : "view"}
                setMaterialData={setMaterialData}
              />
            </div>
          }
        >
          {children}
        </Popconfirm>
      </div>
    );
  };

  const ProductionSchedulesCellHOF: React.FC<{
    colKey: string;
    children: React.ReactNode;
    lineNo: number;
    initialData: any;
    mode: string;
  }> = ({ children, colKey, lineNo, initialData, mode }) => {
    return (
      <div
        style={{
          cursor: "pointer",
        }}
        className="customEditableCell"
      >
        <Popconfirm
          title={<h6>Production Schedule</h6>}
          icon={<></>}
          showCancel={false}
          open={openProductionSchedulesPopUp == lineNo && colKey == popupCol}
          okButtonProps={{
            style: {
              display: "none",
            },
          }}
          onOpenChange={(visible) => {
            if (
              editPriceInfo ||
              editPlanningSchedule ||
              editProductionSchedules ||
              editShipmentSchedules
            )
              return;
            if (visible) {
              if (
                !openPricingInfoPopUp &&
                !openPlanningSchedulePopUp &&
                !openProductionSchedulesPopUp &&
                !openShipmentSchedulesPopUp
              ) {
                setOpenProductionSchedulesPopUp(() => lineNo);
                setPopupCol("productionSchedules");
              }
            }
          }}
          description={
            <div
              style={{
                minWidth: "500px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {editProductionSchedules ? (
                <EditProductionScheduleTable
                  lineNo={lineNo}
                  list={initialData}
                  onSave={setMaterialData}
                  onCancel={() => {
                    setEditProductionSchedules(false);
                    if (initialData?.length == 0) {
                      setPopupCol("");
                      setOpenProductionSchedulesPopUp(null);
                    }
                  }}
                />
              ) : (
                <>
                  <Table
                    className="customTable"
                    columns={[
                      {
                        title: "Production Quantity",
                        dataIndex: "productionQuantity",
                        key: "productionQuantity",
                      },
                      {
                        title: "Planned Start Date",
                        dataIndex: "plannedStartDate",
                        key: "plannedStartDate",
                        render: (text: any, record: any) =>
                          record.plannedStartDate
                            ? dayjs(record.plannedStartDate).format(
                              "DD-MMM-YYYY"
                            )
                            : "",
                      },
                      {
                        title: "Production Lead Days",
                        dataIndex: "productionLeadDays",
                        key: "productionLeadDays",
                        render: (text: any, record: any) =>
                          record.productionLeadDays + " days",
                      },
                      {
                        title: "Planned End Date",
                        dataIndex: "plannedEndDate",
                        key: "plannedEndDate",
                        render: (text: any, record: any) =>
                          record.plannedStartDate
                            ? dayjs(record.plannedStartDate)
                              .add(record.productionLeadDays, "day")
                              .format("DD-MMM-YYYY")
                            : "",
                      },
                    ]}
                    dataSource={initialData}
                    pagination={false}
                    bordered
                    size="small"
                  />

                  <div className="actions clearfix">
                    <ul>
                      {mode == "edit" && (
                        <li>
                          <Button
                            color="primary"
                            size="sm"
                            type="button"
                            onClick={() => setEditProductionSchedules(true)}
                          >
                            {initialData?.length > 0 ? (
                              <>
                                <Icon name="edit" />
                                <span>Edit</span>
                              </>
                            ) : (
                              <>
                                <Icon name="add" />
                                <span>Add</span>
                              </>
                            )}
                          </Button>
                        </li>
                      )}
                      <li>
                        <Button
                          size="sm"
                          color="primary"
                          className="btn-dim btn btn-secondary"
                          type="button"
                          onClick={() => {
                            setEditProductionSchedules(false);
                            setPopupCol("");
                            setOpenProductionSchedulesPopUp(null);
                          }}
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          }
        >
          {children}
        </Popconfirm>
      </div>
    );
  };
  const ShippingSchedulesCellHOF: React.FC<{
    colKey: string;
    children: React.ReactNode;
    lineNo: number;
    initialData: any;
    mode: string;
  }> = ({ children, colKey, lineNo, initialData, mode }) => {
    return (
      <div
        style={{
          cursor: "pointer",
        }}
        className="customEditableCell"
      >
        <Popconfirm
          title={<h6>Shipment Schedule</h6>}
          icon={<></>}
          showCancel={false}
          open={openShipmentSchedulesPopUp == lineNo && colKey == popupCol}
          okButtonProps={{
            style: {
              display: "none",
            },
          }}
          onOpenChange={(visible) => {
            if (
              editPriceInfo ||
              editPlanningSchedule ||
              editProductionSchedules ||
              editShipmentSchedules
            )
              return;
            if (visible) {
              if (
                !openPricingInfoPopUp &&
                !openPlanningSchedulePopUp &&
                !openProductionSchedulesPopUp &&
                !openShipmentSchedulesPopUp
              ) {
                setOpenShipmentSchedulesPopUp(() => lineNo);
                setPopupCol("shipmentSchedules");
              }
            }
          }}
          description={
            <div
              style={{
                minWidth: "500px",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {editShipmentSchedules ? (
                <EditShipmentScheduleTable
                  lineNo={lineNo}
                  list={initialData}
                  onSave={setMaterialData}
                  onCancel={() => {
                    setEditShipmentSchedules(false);
                    if (initialData?.length == 0) {
                      setPopupCol("");
                      setOpenShipmentSchedulesPopUp(null);
                    }
                  }}
                />
              ) : (
                <>
                  <Table
                    className="customTable"
                    columns={[
                      {
                        title: "Shipping Quantity",
                        dataIndex: "shippingQuantity",
                        key: "shippingQuantity",
                      },
                      {
                        title: "Shipping Start Date",
                        dataIndex: "shippingDate",
                        key: "shippingDate",
                        render: (text: any, record: any) =>
                          record.shippingDate
                            ? dayjs(record.shippingDate).format("DD-MMM-YYYY")
                            : "",
                      },
                      {
                        title: "Shipping Lead Days",
                        dataIndex: "shippingLeadDays",
                        key: "shippingLeadDays",
                        render: (text: any, record: any) =>
                          record.shippingLeadDays + " days",
                      },
                      {
                        title: "Shipping End Date",
                        dataIndex: "shippingEndDate",
                        key: "shippingEndDate",
                        render: (text: any, record: any) =>
                          record.shippingDate
                            ? dayjs(record.shippingDate)
                              .add(record.shippingLeadDays, "day")
                              .format("DD-MMM-YYYY")
                            : "",
                      },
                    ]}
                    dataSource={initialData}
                    pagination={false}
                    bordered
                    size="small"
                  />

                  <div className="actions clearfix">
                    <ul>
                      {mode == "edit" && (
                        <li>
                          <Button
                            color="primary"
                            size="sm"
                            type="button"
                            onClick={() => setEditShipmentSchedules(true)}
                          >
                            {initialData?.length > 0 ? (
                              <>
                                <Icon name="edit" />
                                <span>Edit</span>
                              </>
                            ) : (
                              <>
                                <Icon name="add" />
                                <span>Add</span>
                              </>
                            )}
                          </Button>
                        </li>
                      )}
                      <li>
                        <Button
                          size="sm"
                          color="primary"
                          className="btn-dim btn btn-secondary"
                          type="button"
                          onClick={() => {
                            setEditShipmentSchedules(false);
                            setPopupCol("");
                            setOpenShipmentSchedulesPopUp(null);
                          }}
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          }
        >
          {children}
        </Popconfirm>
      </div>
    );
  };

  if (isLoading)
    return (
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin
          indicator={<LoadingOutlined spin />}
          className="m-auto"
          size="large"
        />
      </Flex>
    );

  const { materialsOrServices } = OriginalData || {};
  const isLineLevelDelivery = OriginalData?.isLineLevelDelivery ?? false;
  let NeedByDate = "";
  let DeliveryAddress;
  const BillingAddress = OriginalData?.billingAddress || materialsOrServices?.[0]?.billingAddress || OriginalData?.sealedBidPostalAddress || "-";
  if (OriginalData?.needByDate) {
    NeedByDate = dayjs(OriginalData?.needByDate).format("DD-MMM-YYYY");
  }

  if (isLineLevelDelivery) {
    DeliveryAddress = "Line Level";
  } else {
    DeliveryAddress = OriginalData?.deliveryAddress || materialsOrServices?.[0]?.deliveryAddress || OriginalData?.siteName || "-";
  }

  const SiteAddress = OriginalData?.siteName || "";

  const columns: any = configColumns({ OriginalData, materialData, mode });

  return (
    <>
      <Head title="Purchase Order - Track" />
      <RejectPo
        isModalVisible={disapprovePO}
        setIsModalVisible={setDisapprovePO}
        rejectTender={rejectTender}
      />
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            <div className="card-inner card-inner-lg">
              {sm && mobileView && (
                <div
                  className="toggle-overlay"
                  onClick={() => setSm(!sm)}
                ></div>
              )}
              <BlockHead size="lg">
                <BlockBetween>
                  <BlockHeadContent>
                    <BlockTitle tag="h4">
                      <span>
                        {OriginalData?.tenderNumber || tenderId} |{" "}
                        <GetTenderStatusTag
                          status={OriginalData?.supplierBidStatus || ""}
                        />{" "}
                        {OriginalData?.supplierBidStatus === "Partially Awarded" && (
                          <>
                            <span style={{ color: "#888" }}> | </span>
                            <span style={{ color: "#DAA520", fontSize: 18 }}>
                              Score: <strong>80%</strong>
                            </span>
                            <span style={{ color: "#888" }}> | </span>
                            <Tag color="success">Rank #1</Tag>
                          </>
                        )}
                      </span>
                    </BlockTitle>
                  </BlockHeadContent>
                  <div className="d-flex">
                    {["New Tender"].includes(OriginalData?.supplierBidStatus || "") &&
                      !showSubmitBtm && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            <li>
                              {disableApprove ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  style={{
                                    background: "	#2ecc71",
                                    border: "1px solid 	#2ecc71",
                                  }}
                                  type="button"
                                  size="sm"
                                  onClick={() => {
                                    setDisableApprove(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to send your interest?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, send it!",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        ApproveTender();
                                      } else {
                                        setDisableApprove(false);
                                      }
                                    });
                                  }}
                                >
                                  Interested
                                </Button>
                              )}
                            </li>
                            <li>
                              {disableReject ? (
                                <Button color="danger" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="secondary"
                                  size="sm"
                                  onClick={() => {
                                    setDisableReject(true);
                                    setDisapprovePO(true);
                                  }}
                                  type="button"
                                  className="btn-dim btn btn-secondary"
                                >
                                  Not Interested
                                </Button>
                              )}
                            </li>
                          </ul>
                        </div>
                      )}

                    {mode == "edit" && (
                      <div className="actions clearfix">
                        <ul
                          className="m-auto d-flex align-items-center justify-content-center p-0"
                          style={{
                            flexDirection: "row-reverse",
                          }}
                        >
                          <li>
                            {disableSubmit ? (
                              <Button color="primary" type="button">
                                <Spinner size="sm" color="light" />
                              </Button>
                            ) : (
                              <Button
                                color="primary"
                                type="button"
                                size="sm"
                                onClick={() => {
                                  if (
                                    !ValidateMaterialsData(
                                      materialData,
                                      OriginalData
                                    )
                                  )
                                    return;
                                  else {
                                    setMaterialInfoAlert({
                                      type: "success",
                                      message: "",
                                      open: false,
                                    });
                                  }
                                  setDisableSubmit(true);
                                  setQuestionnaireInfoAlert({
                                    type: "danger",
                                    message: "",
                                    open: false,
                                  });
                                  if (
                                    OriginalData?.supplierBidStatus == "Interested" &&
                                    !isTermsAccepted
                                  ) {
                                    setTermsAndConditionsInfoAlert({
                                      type: "danger",
                                      message:
                                        "Please accept terms and conditions",
                                      open: true,
                                    });
                                    setDisableSubmit(false);
                                    termsAndConditionsAlertRef?.current?.scrollIntoView(
                                      {
                                        behavior: "smooth",
                                      }
                                    );
                                    return;
                                  }
                                  const isUpdate = OriginalData?.supplierBidStatus === "Responded";
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to Save your changes?",
                                    icon: "warning",
                                    ...(isUpdate ? {
                                      input: "textarea",
                                      inputLabel: "Revision Reason",
                                      inputPlaceholder: "Enter revision reason...",
                                    } : {}),
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, Save it!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      const revisionReason = isUpdate ? result.value : undefined;
                                      methods.handleSubmit(
                                        (successData) => {
                                          if (isUpdate) {
                                            UpdateBidChanges(successData, revisionReason);
                                          } else {
                                            SubmitChanges(successData);
                                          }
                                        },
                                        (errorData) => {
                                          try {
                                            console.log(errorData);

                                            for (let questionerSectionId in questioners) {
                                              const questionSection =
                                                questioners[
                                                questionerSectionId
                                                ];

                                              let question: any;
                                              for (question of questionSection?.questions) {
                                                const errorObj =
                                                  errorData[
                                                  question?.questionId
                                                  ];
                                                if (errorObj) {
                                                  setQuestionnaireInfoAlert({
                                                    type: "danger",
                                                    message:
                                                      "Please answer all the questions in " +
                                                      questionSection?.sectionName +
                                                      " section",
                                                    open: true,
                                                  });
                                                  questionnaireAlertRef?.current?.scrollIntoView(
                                                    {
                                                      behavior: "smooth",
                                                    }
                                                  );
                                                  setActiveTab(
                                                    questionerSectionId
                                                  );
                                                  return;
                                                }
                                              }
                                            }
                                          } catch (error) {
                                            console.log(
                                              "Error in errorData",
                                              error
                                            );
                                          } finally {
                                            setDisableSubmit(false);
                                          }
                                        }
                                      )();
                                    } else {
                                      setDisableSubmit(false);
                                    }
                                  });
                                }}
                              >
                                {OriginalData?.supplierBidStatus === "Responded" ? "Update" : "Submit"}
                              </Button>
                            )}
                          </li>
                          <li>
                            {disableDiscard ? (
                              <Button color="secondary" type="button">
                                <Spinner size="sm" color="light" />
                              </Button>
                            ) : (
                              <Button
                                color="secondary"
                                size="sm"
                                onClick={() => {
                                  setDisableDiscard(true);
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to discard the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, discard it!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      setDisableDiscard(false);
                                      setMode("view");
                                      reset();
                                      fetchOrderDetails();
                                    }
                                  });
                                }}
                                type="button"
                                className="btn-dim btn btn-secondary"
                              >
                                Discard
                              </Button>
                            )}
                          </li>
                        </ul>
                      </div>
                    )}

                    {!showSubmitBtm && (
                      <ul className="nk-ibx-head-tools g-1 m-0 p-0 ">
                        {OriginalData?.supplierBidStatus === "Responded" && mode !== "edit" &&
                          dayjs().isBefore(dayjs(OriginalData?.lastSubmissionDate)) && (
                          <li>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => setMode("edit")}
                            >
                              <span>Update Bid</span>
                            </Button>
                          </li>
                        )}
                        {OriginalData?.supplierBidStatus === "Interested" && mode !== "edit" && (
                          <li>
                            <Button
                              color="primary"
                              size="sm"
                              onClick={() => setMode("edit")}
                            >
                              <span>Respond</span>
                            </Button>
                          </li>
                        )}
                        <li>
                          <Button
                            className="toggle"
                            color="primary"
                            size="sm"
                            onClick={async () => {
                              navigate("/home");
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </li>
                      </ul>
                    )}
                  </div>
                  <BlockHeadContent className="align-self-start d-lg-none">
                    <Button
                      className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                        }`}
                      onClick={() => setSm(!sm)}
                    >
                      <Icon name="menu-alt-r" />
                    </Button>
                  </BlockHeadContent>
                </BlockBetween>
              </BlockHead>
              <Alert
                isOpen={OriginalData?.supplierBidStatus === "Not Interested"}
                color="danger"
                className="start-0 w-100 py-1 mt-1"
                style={{
                  top: 0,
                  textAlign: "left",
                  fontSize: "14px",
                  cursor: "default",
                }}
              >
                <Tooltip title={OriginalData?.notInterestedReason}>
                  <span
                    className="fw-bold"
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    View Reason,
                  </span>
                </Tooltip>{" "}
                <ReactTyped
                  strings={[
                    " As you are not interested in this tender, you can no longer make any actions.",
                  ]}
                  typeSpeed={5}
                  showCursor={false}
                />
              </Alert>

              <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>General Details</>
                    </div>
                  }
                  key="1"
                >
                  <div className="p-0">
                    <Descriptions
                      title={undefined}
                      className="custom-description-title ps-1"
                    >
                      <Descriptions.Item label="Tender Title">
                        {OriginalData?.tenderTitle || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Customer">
                        {OriginalData?.createdByUserName}
                      </Descriptions.Item>
                      <Descriptions.Item label="Requested By">
                        {OriginalData?.createdByUserName}
                      </Descriptions.Item>
                      <Descriptions.Item label="Payment Terms">
                        {OriginalData?.paymentTerms || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Site Name">
                        {OriginalData?.siteName || "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last Submission">
                        {OriginalData?.lastSubmissionDate
                          ? dayjs(OriginalData.lastSubmissionDate).format("DD/MMM/YYYY hh:mm A")
                          : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Last Date for Expressing Interest">
                        {OriginalData?.lastDateForExpressingInterest
                          ? dayjs(OriginalData.lastDateForExpressingInterest).format("DD/MMM/YYYY hh:mm A")
                          : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Evaluation Start Date">
                        {OriginalData?.evaluationStartDate
                          ? dayjs(OriginalData.evaluationStartDate).format("DD/MMM/YYYY hh:mm A")
                          : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Sealed Bid Submission Date">
                        {OriginalData?.sealedBidSubmissionDate
                          ? dayjs(OriginalData.sealedBidSubmissionDate).format("DD/MMM/YYYY hh:mm A")
                          : "-"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Billing Address">
                        <Tooltip title={BillingAddress}>
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            View
                          </span>
                        </Tooltip>
                      </Descriptions.Item>
                      <Descriptions.Item label="Delivery Address">
                        <Tooltip title={DeliveryAddress}>
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            View
                          </span>
                        </Tooltip>
                      </Descriptions.Item>
                      <Descriptions.Item label="Site Address">
                        <Tooltip title={SiteAddress}>
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            View
                          </span>
                        </Tooltip>
                      </Descriptions.Item>
                      <Descriptions.Item label="Description">
                        <Tooltip title={OriginalData?.description}>
                          <span
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: 700,
                              display: "inline-block",
                            }}
                          >
                            {OriginalData?.description}
                          </span>
                        </Tooltip>
                      </Descriptions.Item>
                    </Descriptions>
                  </div>
                </Panel>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>Material Information</>
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "8px" }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {mode === "edit" && (
                          <>
                            <div
                              onClick={handleExportMaterials}
                              className="btn btn-white btn-outline-light"
                            >
                              <Icon name="download-cloud" />
                              <span>Export</span>
                            </div>
                            <div
                              onClick={() => fileInputRef.current?.click()}
                              className="btn btn-white btn-outline-light"
                            >
                              <Icon name="upload-cloud" />
                              <span>Import</span>
                            </div>
                            <input
                              ref={fileInputRef}
                              type="file"
                              accept=".xlsx,.xls"
                              style={{ display: "none" }}
                              onChange={handleImportMaterials}
                            />
                          </>
                        )}
                        {OriginalData?.status === "Evaluated" && (
                          <div
                            onClick={() => {
                              setLineDiscounts({});
                              setDiscountRevisionReason("");
                              setDiscountDrawerOpen(true);
                            }}
                            className="btn btn-white btn-outline-light"
                          >
                            <Icon name="percent" />
                            <span>Discount</span>
                          </div>
                        )}
                      </div>
                    </div>
                  }
                  key="2"
                >
                  <span ref={materialInfoAlertRef}></span>

                  <Alert
                    color={materialInfoAlert.type}
                    isOpen={materialInfoAlert.open}
                    className="start-0 w-100 py-1 mt-1"
                    style={{
                      top: 0,
                      textAlign: "left",
                      fontSize: "14px",
                      cursor: "default",
                    }}
                  >
                    <ReactTyped
                      strings={[materialInfoAlert.message]}
                      typeSpeed={5}
                      showCursor={false}
                    />
                  </Alert>

                  <div className="table-responsive poTable">
                    <div
                      style={{
                        width: screenSize - 120 + "px",
                        margin: "0px auto 15px auto",
                      }}
                    >
                      <Table
                        className="customTable"
                        columns={columns}
                        dataSource={materialData}
                        rowKey={(record: any) => record?.tenderMaterialId || record?.materialId || record?.lineNo || record?.key}
                        rowClassName={(record: any) => record?._importError ? "import-error-row" : ""}
                        scroll={{
                          x: "max-content",
                        }}
                        expandable={{
                          expandedRowKeys,
                          onExpand: (expanded: boolean, record: any) => {
                            const key = record?.tenderMaterialId || record?.materialId || record?.lineNo || record?.key;
                            setExpandedRowKeys(expanded ? [key] : []);
                          },
                          expandedRowRender: (record: any) => {
                            if (record?.key == "lastRow") {
                              return <></>;
                            }
                            return (
                              <div style={{ display: "flex", flexDirection: "column", gap: 8, textAlign: "left" }}>
                                {record?._importError && (
                                  <div
                                    style={{
                                      background: "#fff2f0",
                                      border: "1px solid #ffccc7",
                                      borderRadius: 4,
                                      padding: "6px 12px",
                                      color: "#cf1322",
                                      fontSize: 13,
                                    }}
                                  >
                                    <CloseCircleTwoTone twoToneColor="#f5222d" style={{ marginRight: 6 }} />
                                    {record._importError}
                                  </div>
                                )}
                                <div className="expandableBody">
                                <div style={{ flex: 1, textAlign: "left" }}>
                                  <p style={{ margin: 0 }}>
                                    {record.description}
                                  </p>
                                  {record.attachment && (
                                    <div>
                                      <PaperClipOutlined /> &nbsp;
                                      {record?.file[0]?.name ? (
                                        <a
                                          href={URL.createObjectURL(
                                            record.file[0]
                                          )}
                                          download={record.file[0]?.name}
                                        >
                                          {record.file[0]?.name}
                                        </a>
                                      ) : (
                                        <a
                                          href={record?.file?.filePath}
                                          download={record?.file?.filePath}
                                          target="_blank"
                                        >
                                          {record?.file?.fileName}
                                        </a>
                                      )}
                                    </div>
                                  )}
                                </div>
                                {materialData?.deliveryAddressType ===
                                  "Line Level" &&
                                  record.deliveryAddressId && (
                                    <div
                                      className="lineAddress"
                                      style={{ flex: 1 }}
                                    >
                                      <h6>Delivery Address</h6>
                                      <ShowAddressPopOver
                                        id={record.deliveryAddressId}
                                      />
                                    </div>
                                  )}
                              </div>
                            </div>
                            );
                          },
                        }}
                        locale={{
                          emptyText: (
                            <span
                              style={{
                                height: "300px",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              There Is No Material
                            </span>
                          ),
                        }}
                        bordered
                        size="middle"
                        pagination={{
                          current: materialPageCurrent,
                          pageSize: materialPageSize,
                          total: materialData?.length || 0,
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100"],
                          showTotal: (total: number, range: [number, number]) =>
                            `${range[0]}-${range[1]} of ${total} items`,
                          onChange: (page: number, pageSize: number) => {
                            setMaterialPageCurrent(page);
                            setMaterialPageSize(pageSize);
                          },
                        }}
                      />
                    </div>
                  </div>

                  {/* Material Totals Summary */}
                  {materialData?.length > 0 &&
                    !["New Tender", "Not Interested"].includes(
                      OriginalData?.supplierBidStatus
                    ) && (() => {
                      const bid = OriginalData?.bidDetails;
                      const hasInstallation = materialData?.some((m: any) => m.isInstallationRequired || m.pricingInfo?.installationCharges != null) ||
                        OriginalData?.materials?.some((m: any) => m.isInstallationRequired);

                      let subtotal = 0;
                      let totalDiscount = 0;
                      let totalInstallation = 0;
                      let totalTaxAmount = 0;

                      if (mode === "view" && bid) {
                        subtotal = Number(bid.subTotal || 0);
                        totalDiscount = Number(bid.totalDiscount || 0);
                        totalInstallation = Number(bid.totalInstallationCharges || 0);
                        totalTaxAmount = Number(bid.taxValue || 0);
                      } else {
                        materialData.forEach((m: any) => {
                          const price = m?.pricingInfo?.unitPrice ?? m?.unitPrice ?? 0;
                          const qty = m?.pricingInfo?.supplyQuantity ?? m?.quantity ?? 0;
                          const installation = Number(m?.pricingInfo?.installationCharges || 0);
                          const discountPct = Number(m?.pricingInfo?.discount || 0);
                          const taxPct = Number(m?.pricingInfo?.taxPercentage || 0);
                          const lineSubTotal = Number(qty) * Number(price);
                          const lineDiscount = (lineSubTotal * discountPct) / 100;
                          const discountedSubTotal = lineSubTotal - lineDiscount;
                          const lineTotalInstallation = Number(qty) * installation;
                          const taxableAmount = discountedSubTotal + lineTotalInstallation;
                          const taxAmount = (taxableAmount * taxPct) / 100;

                          subtotal += lineSubTotal;
                          totalDiscount += lineDiscount;
                          totalInstallation += lineTotalInstallation;
                          totalTaxAmount += taxAmount;
                        });
                      }

                      const taxableTotal = mode === "view" && bid ? Number(bid.netValue || 0) : (subtotal - totalDiscount) + totalInstallation;
                      const grandTotal = mode === "view" && bid ? Number(bid.grossValue || 0) : taxableTotal + totalTaxAmount;

                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "12px 16px",
                          }}
                        >
                          <div
                            style={{
                              minWidth: 340,
                              border: "1px solid #f0f0f0",
                              borderRadius: 6,
                              overflow: "hidden",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px 16px",
                                borderBottom: "1px solid #f0f0f0",
                                fontSize: 13,
                                color: "#555",
                              }}
                            >
                              <span>Subtotal</span>
                              <span>{formatCurrency(subtotal.toFixed(2), "INR")}</span>
                            </div>
                            {totalDiscount > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px 16px",
                                borderBottom: "1px solid #f0f0f0",
                                fontSize: 13,
                                color: "#cf1322",
                              }}
                            >
                              <span>Discount</span>
                              <span>-{formatCurrency(totalDiscount.toFixed(2), "INR")}</span>
                            </div>
                            )}
                            {hasInstallation && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px 16px",
                                borderBottom: "1px solid #f0f0f0",
                                fontSize: 13,
                                color: "#555",
                              }}
                            >
                              <span>Installation Charges</span>
                              <span>{formatCurrency(totalInstallation.toFixed(2), "INR")}</span>
                            </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px 16px",
                                borderBottom: "1px solid #f0f0f0",
                                fontSize: 13,
                                color: "#555",
                              }}
                            >
                              <span>Taxable Amount</span>
                              <span>{formatCurrency(taxableTotal.toFixed(2), "INR")}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "8px 16px",
                                borderBottom: "1px solid #f0f0f0",
                                fontSize: 13,
                                color: "#555",
                              }}
                            >
                              <span>Tax Amount</span>
                              <span>{formatCurrency(totalTaxAmount.toFixed(2), "INR")}</span>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "10px 16px",
                                background: "#f8f9fa",
                                fontSize: 14,
                                fontWeight: 700,
                                color: "#1a1a1a",
                              }}
                            >
                              <span>Grand Total</span>
                              <span>{formatCurrency(grandTotal.toFixed(2), "INR")}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })()}
                </Panel>
                <Panel
                  header={
                    <div className="d-flex align-items-center justify-content-between">
                      <>Information</>
                      {TabsList?.length > 0 && (
                        <span
                          style={{
                            fontSize: "12px",
                            fontWeight: 600,
                            color:
                              TabsList.reduce((sum, tab) => {
                                const section = questioners[tab.tabKey];
                                return sum + (section?.totalWeightage || 0);
                              }, 0) === 100
                                ? "#28a745"
                                : "#dc3545",
                            marginLeft: "10px",
                          }}
                        >
                          Total Weightage:{" "}
                          {TabsList.reduce((sum, tab) => {
                            const section = questioners[tab.tabKey];
                            return sum + (section?.totalWeightage || 0);
                          }, 0)}
                          %
                          {TabsList.reduce((sum, tab) => {
                            const section = questioners[tab.tabKey];
                            return sum + (section?.totalWeightage || 0);
                          }, 0) === 100
                            ? " ✓"
                            : " (Must be 100%)"}
                        </span>
                      )}
                    </div>
                  }
                  key="3"
                >
                  <Alert
                    color={questionnaireInfoAlert.type}
                    isOpen={questionnaireInfoAlert.open}
                    className="start-0 w-100 py-1 mt-1"
                    style={{
                      top: 0,
                      textAlign: "left",
                      fontSize: "14px",
                      cursor: "default",
                    }}
                  >
                    <ReactTyped
                      strings={[questionnaireInfoAlert.message]}
                      typeSpeed={5}
                      showCursor={false}
                    />
                  </Alert>

                  <FormProvider {...methods}>
                    <form className="content clearfix mt-0 ps-1">
                      {TabsList?.length > 0 && (
                        <div className="d-flex align-items-center flex-wrap mb-2 mt-0">
                          <ul className="nav nav-tabs nav-tabs-card nav-tabs-xs w-100 p-0 m-0 position-relative ">
                            {TabsList?.map((_tab: any, index: number) => {
                              return (
                                <li
                                  className="nav-item"
                                  key={_tab?.tabKey}
                                  onClick={() =>
                                    setActiveTab(() => _tab?.tabKey)
                                  }
                                >
                                  <a
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                    }}
                                    className={`nav-link${activeTab === _tab?.tabKey
                                      ? " active"
                                      : ""
                                      }`}
                                    href={"#" + _tab?.tabKey}
                                  >
                                    {_tab?.label}
                                  </a>
                                </li>
                              );
                            })}
                          </ul>
                          <div className="tab-content mt-2 w-100">
                            <span ref={questionnaireAlertRef}></span>
                            {Object.keys(questioners)?.map(
                              (questionerSectionId: string) => {
                                const questioner =
                                  questioners?.[questionerSectionId];
                                const { questions } = questioner;
                                return (
                                  <div
                                    key={questionerSectionId}
                                    className={`tab-pane${activeTab == questionerSectionId
                                      ? " active"
                                      : " "
                                      }`}
                                  >
                                    <Table
                                      className="customTable"
                                      columns={[
                                        {
                                          title: "Question",
                                          dataIndex: "description",
                                          key: "description",
                                          render: (
                                            description: any,
                                            record: any
                                          ) => {
                                            return (
                                              <div>
                                                <span>
                                                  {description}{" "}
                                                  {record.mandatory && (
                                                    <span className="mandatory">
                                                      *
                                                    </span>
                                                  )}
                                                </span>
                                              </div>
                                            );
                                          },
                                        },
                                        {
                                          title: "Question Type",
                                          dataIndex: "type",
                                          key: "type",
                                          width: 120,
                                          render: (type: string) => {
                                            return (
                                              <div>
                                                <span>{type}</span>
                                              </div>
                                            );
                                          },
                                        },
                                        {
                                          title: "Weightage",
                                          dataIndex: "weightage",
                                          key: "weightage",
                                          width: 80,
                                          render: (weightage: any) => {
                                            return (
                                              <div>
                                                <span>{weightage} %</span>
                                              </div>
                                            );
                                          },
                                        },
                                        {
                                          title: "Answer",
                                          key: "answer",
                                          width: 300,
                                          render: (
                                            answer: any,
                                            record: any
                                          ) => {
                                            const {
                                              type,
                                              questionId,
                                              mandatory,
                                              options,
                                            } = record;
                                            const files = watch(questionId);
                                            switch (type) {
                                              case "Yes/No":
                                                return (
                                                  <div>
                                                    <FormSelect
                                                      name={questionId}
                                                      label={undefined}
                                                      required={mandatory}
                                                      disabled={mode == "view"}
                                                      unMaskView={
                                                        mode == "view"
                                                      }
                                                      placeholder="Select Answer"
                                                      options={[
                                                        {
                                                          value: "Yes",
                                                          label: "Yes",
                                                        },
                                                        {
                                                          value: "No",
                                                          label: "No",
                                                        },
                                                      ]}
                                                    />
                                                  </div>
                                                );
                                              case "Single Choice":
                                                return (
                                                  <div>
                                                    <FormSelect
                                                      name={questionId}
                                                      label={undefined}
                                                      required={mandatory}
                                                      disabled={mode == "view"}
                                                      unMaskView={
                                                        mode == "view"
                                                      }
                                                      placeholder="Select Answer"
                                                      options={options?.map(
                                                        (option: any) => ({
                                                          value: option,
                                                          label: option,
                                                        })
                                                      )}
                                                    />
                                                  </div>
                                                );
                                              case "Multi Choice":
                                              case "Multiple Choice":
                                                return (
                                                  <div>
                                                    <FormMultiSelect
                                                      name={questionId}
                                                      label={undefined}
                                                      required={mandatory}
                                                      disabled={mode == "view"}
                                                      unMaskView={
                                                        mode == "view"
                                                      }
                                                      placeholder="Select Answer"
                                                      options={options?.map(
                                                        (option: any) => ({
                                                          value: option,
                                                          label: option,
                                                        })
                                                      )}
                                                    />
                                                  </div>
                                                );
                                              case "Short Text":
                                                return (
                                                  <div>
                                                    <FormInput
                                                      name={questionId}
                                                      label={undefined}
                                                      required={mandatory}
                                                      disabled={mode == "view"}
                                                      unMaskView={
                                                        mode == "view"
                                                      }
                                                    />
                                                  </div>
                                                );
                                              case "Long Text":
                                                return (
                                                  <div>
                                                    <FormTextArea
                                                      name={questionId}
                                                      label={undefined}
                                                      required={mandatory}
                                                      disabled={mode == "view"}
                                                      placeholder="e.g., Please provide a detailed description of your company's experience in similar projects, including scope, duration, and outcomes."
                                                      rows={4}
                                                    />
                                                  </div>
                                                );
                                              case "File Upload":
                                                console.log(
                                                  "===================================="
                                                );
                                                console.log("files", files);
                                                console.log(
                                                  "===================================="
                                                );
                                                return (
                                                  <div>
                                                    {files &&
                                                      files[0]?.name && (
                                                        <div className="form-group m-0">
                                                          <div
                                                            className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                                                            style={{
                                                              borderRadius:
                                                                "3px",
                                                            }}
                                                          >
                                                            <span>
                                                              {files &&
                                                                files[0]?.name}
                                                            </span>
                                                            <span
                                                              onClick={() => {
                                                                setValue(
                                                                  questionId,
                                                                  null
                                                                );
                                                              }}
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                marginLeft:
                                                                  "10px",
                                                                display:
                                                                  mode == "view"
                                                                    ? "none"
                                                                    : "block",
                                                                fontSize: 14,
                                                              }}
                                                            >
                                                              <Icon name="cross"></Icon>{" "}
                                                              &nbsp;
                                                            </span>
                                                          </div>
                                                        </div>
                                                      )}
                                                    <div
                                                      style={{
                                                        display: `${files &&
                                                          files[0]?.name
                                                          ? "none"
                                                          : "block"
                                                          }`,
                                                      }}
                                                    >
                                                      <FormInput
                                                        type="file"
                                                        name={questionId}
                                                        label={undefined}
                                                        disabled={
                                                          mode == "view"
                                                        }
                                                        required={mandatory}
                                                        // unMaskView={mode=="view"}
                                                        placeholder="Enter Attachment"
                                                      />
                                                    </div>
                                                  </div>
                                                );
                                              default:
                                                return (
                                                  <div>
                                                    <span>-{type}-</span>
                                                  </div>
                                                );
                                            }
                                          },
                                        },
                                        {
                                          title: "Remark",
                                          key: "remark",
                                          width: 300,
                                          render: (
                                            answer: any,
                                            record: any
                                          ) => {
                                            const {
                                              type,
                                              questionId,
                                              mandatory,
                                            } = record;

                                            return (
                                              <div>
                                                <FormInput
                                                  name={
                                                    questionId + "--remarks"
                                                  }
                                                  label={undefined}
                                                  disabled={mode == "view"}
                                                  unMaskView={mode == "view"}
                                                />
                                              </div>
                                            );
                                          },
                                        },
                                      ]}
                                      dataSource={questions}
                                      pagination={false}
                                      bordered
                                      rowKey="key"
                                      locale={{
                                        emptyText: (
                                          <>
                                            <Empty
                                              image={
                                                Empty.PRESENTED_IMAGE_SIMPLE
                                              }
                                              description={
                                                <>
                                                  <strong>
                                                    No Questions Found, Please
                                                    Skip this Section
                                                  </strong>
                                                </>
                                              }
                                            />
                                          </>
                                        ),
                                      }}
                                    />
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                      )}
                    </form>
                  </FormProvider>
                </Panel>
              </AntCollapse>

              <span ref={termsAndConditionsAlertRef}></span>

              <Alert
                color={termsAndConditionsInfoAlert.type}
                isOpen={termsAndConditionsInfoAlert.open}
                className="start-0 w-100 py-1 mt-1"
                style={{
                  top: 0,
                  textAlign: "left",
                  fontSize: "14px",
                  cursor: "default",
                }}
              >
                <ReactTyped
                  strings={[termsAndConditionsInfoAlert.message]}
                  typeSpeed={5}
                  showCursor={false}
                />
              </Alert>

              <div className="content clearfix my-2 mb-4">
                {mode === "edit" ? (
                  <>
                    {"Interested" == OriginalData?.supplierBidStatus && (
                      <div className="mb-2 ps-1">
                        <Checkbox
                          checked={isTermsAccepted}
                          onChange={(e) => {
                            setTermsAndConditionsInfoAlert({
                              open: false,
                              message: "",
                              type: "success",
                            });
                            setIsTermsAccepted(e.target.checked);
                          }}
                        ></Checkbox>
                        <span>
                          {" "}
                          I agree to the{" "}
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setTermsVisible(true)}
                          >
                            terms and conditions
                          </span>
                          . <span style={{ color: "red" }}>*</span>
                        </span>
                      </div>
                    )}
                  </>
                ) : (
                  <Descriptions title="" className="custom-description-title">
                    <Descriptions.Item label="Instructions">
                      <span
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setInstructionsVisible(true)}
                      >
                        View
                      </span>
                    </Descriptions.Item>
                    <Descriptions.Item label="Terms and Conditions">
                      <span
                        style={{
                          color: "#2263b3",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setTermsVisible(true)}
                      >
                        View
                      </span>
                    </Descriptions.Item>
                    <Descriptions.Item label={<span>Attachments <PaperClipOutlined /></span>}>
                      {documents?.filter((doc: any) => doc.moduleFileType !== "TermsAndConditions" && doc.moduleFileType !== "Instructions").length > 0 ? (
                        <div className="d-flex flex-column gap-1">
                          {documents.filter((doc: any) => doc.moduleFileType !== "TermsAndConditions" && doc.moduleFileType !== "Instructions").map((doc: any, index: number) => (
                            <div
                              key={doc?.docId || index}
                              className="d-flex align-items-center"
                              style={{ gap: "8px" }}
                            >
                              <Tooltip title={doc?.fileName}>
                                <span
                                  style={{
                                    maxWidth: "200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    display: "inline-block",
                                  }}
                                >
                                  {doc?.fileName}
                                </span>
                              </Tooltip>
                              <a
                                href={doc?.filePath}
                                download={doc?.fileName}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "black",
                                  fontSize: "18px",
                                  cursor: "pointer",
                                  flexShrink: 0,
                                }}
                              >
                                <DownloadOutlined />
                              </a>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>N/A</span>
                      )}
                    </Descriptions.Item>
                  </Descriptions>
                )}

                <AntModal
                  title="Instructions"
                  visible={instructionsVisible}
                  footer={null}
                  onCancel={() => setInstructionsVisible(false)}
                  width="60%"
                  bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  {instructions ? (
                    <div dangerouslySetInnerHTML={{ __html: instructions }} />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty description="No Instructions Provided" />
                    </div>
                  )}
                </AntModal>
                <AntModal
                  title="Terms and Conditions"
                  visible={termsVisible}
                  footer={null}
                  onCancel={() => setTermsVisible(false)}
                  width="60%"
                  bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
                >
                  {termsAndConditions ? (
                    <div dangerouslySetInnerHTML={{ __html: termsAndConditions }} />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "200px",
                      }}
                    >
                      <Empty description="No Terms and Conditions Provided" />
                    </div>
                  )}
                </AntModal>

                <Block>
                  {showCropModel && (
                    <CropperComponent
                      modal={showCropModel}
                      toggle={() => setShowCropModel(!showCropModel)}
                      onSave={(data: string) => {
                        setSignature((pre: any) => {
                          return { ...pre, image: data };
                        });
                        setShowCropModel(false);
                      }}
                    />
                  )}
                </Block>
              </div>
            </div>
          </div>
        </Card>
      {/* Discount Drawer */}
      <Drawer
        title={
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <span style={{ fontSize: 16, fontWeight: 600 }}>Apply Discount</span>
            <div style={{ display: "flex", gap: 8 }}>
              <div
                className="btn btn-white btn-outline-light"
                onClick={handleDiscountExport}
                style={{ cursor: "pointer" }}
              >
                <Icon name="download-cloud" />
                <span>Export</span>
              </div>
              <div
                className="btn btn-white btn-outline-light"
                onClick={() => discountFileInputRef.current?.click()}
                style={{ cursor: "pointer" }}
              >
                <Icon name="upload-cloud" />
                <span>Import</span>
              </div>
              <input
                ref={discountFileInputRef}
                type="file"
                accept=".xlsx,.xls"
                style={{ display: "none" }}
                onChange={handleDiscountImport}
              />
            </div>
          </div>
        }
        placement="right"
        width="80%"
        open={discountDrawerOpen}
        onClose={() => setDiscountDrawerOpen(false)}
        footer={
          <div className="actions clearfix">
            <ul style={{ display: "flex", listStyle: "none", margin: 0, padding: 0, gap: 8 }}>
              <li>
                <Button
                  color="primary"
                  onClick={handleApplyDiscountClick}
                  disabled={applyingDiscount}
                >
                  {applyingDiscount ? "Applying..." : "Apply Discount"}
                </Button>
              </li>
              <li>
                <Button
                  className="btn-dim btn-secondary"
                  onClick={() => setDiscountDrawerOpen(false)}
                >
                  Cancel
                </Button>
              </li>
            </ul>
          </div>
        }
      >
        <Table
          dataSource={getDiscountDrawerMaterials()}
          columns={[
            {
              title: "Material Name",
              dataIndex: "materialName",
              key: "materialName",
              width: 200,
            },
            {
              title: "Usage",
              dataIndex: "usage",
              key: "usage",
              width: 100,
            },
            {
              title: "Supply Qty",
              dataIndex: "supplyQty",
              key: "supplyQty",
              width: 100,
              align: "center" as const,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 130,
              align: "right" as const,
              render: (val: number) => formatCurrency(val, "INR"),
            },
            {
              title: "Installation Charges",
              dataIndex: "installationCharges",
              key: "installationCharges",
              width: 150,
              align: "right" as const,
              render: (val: number) => formatCurrency(val, "INR"),
            },
            {
              title: "Total Price",
              dataIndex: "totalPrice",
              key: "totalPrice",
              width: 150,
              align: "right" as const,
              render: (val: number) => <b>{formatCurrency(val, "INR")}</b>,
            },
            {
              title: "Discount (%)",
              key: "discount",
              width: 120,
              align: "center" as const,
              render: (_: any, record: any) => (
                <InputNumber
                  min={0}
                  max={100}
                  size="small"
                  style={{ width: "100%" }}
                  placeholder="Enter %"
                  value={lineDiscounts[record.tenderMaterialId] || undefined}
                  onChange={(val: any) =>
                    setLineDiscounts((prev) => ({
                      ...prev,
                      [record.tenderMaterialId]: val || 0,
                    }))
                  }
                />
              ),
            },
            {
              title: "Discount Amt",
              key: "discountAmt",
              width: 140,
              align: "right" as const,
              render: (_: any, record: any) => {
                const disc = lineDiscounts[record.tenderMaterialId] || 0;
                const amt = (record.totalPrice * disc) / 100;
                return disc > 0 ? (
                  <span style={{ color: "#cf1322", fontWeight: 600 }}>
                    - {formatCurrency(amt, "INR")}
                  </span>
                ) : "-";
              },
            },
            {
              title: "After Discount",
              key: "afterDiscount",
              width: 150,
              align: "right" as const,
              render: (_: any, record: any) => {
                const disc = lineDiscounts[record.tenderMaterialId] || 0;
                const amt = (record.totalPrice * disc) / 100;
                const afterDiscount = record.totalPrice - amt;
                return disc > 0 ? (
                  <b style={{ color: "#28A745" }}>{formatCurrency(afterDiscount, "INR")}</b>
                ) : <b>{formatCurrency(record.totalPrice, "INR")}</b>;
              },
            },
          ]}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            showTotal: (total: number, range: [number, number]) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
          scroll={{ x: "max-content" }}
          size="small"
          bordered
          rowKey="tenderMaterialId"
          summary={() => {
            const materials = getDiscountDrawerMaterials();
            let totalOriginal = 0;
            let totalDiscountAmt = 0;
            materials.forEach((mat: any) => {
              totalOriginal += mat.totalPrice;
              const disc = lineDiscounts[mat.tenderMaterialId] || 0;
              totalDiscountAmt += (mat.totalPrice * disc) / 100;
            });
            return (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0} colSpan={5}>
                    <b>Total</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={5} align="right">
                    <b>{formatCurrency(totalOriginal, "INR")}</b>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={6} />
                  <Table.Summary.Cell index={7} align="right">
                    {totalDiscountAmt > 0 ? (
                      <span style={{ color: "#cf1322", fontWeight: 600 }}>
                        - {formatCurrency(totalDiscountAmt, "INR")}
                      </span>
                    ) : "-"}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={8} align="right">
                    {totalDiscountAmt > 0 ? (
                      <b style={{ color: "#28A745" }}>
                        {formatCurrency(totalOriginal - totalDiscountAmt, "INR")}
                      </b>
                    ) : <b>{formatCurrency(totalOriginal, "INR")}</b>}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      </Drawer>

      {/* Discount Revision Reason Modal */}
      <AntModal
        title={<span style={{ fontSize: 16, fontWeight: 600 }}>Revision Reason</span>}
        open={discountReasonModalOpen}
        zIndex={1100}
        width={500}
        onCancel={() => {
          setDiscountReasonModalOpen(false);
          setDiscountRevisionReason("");
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button
              className="btn-dim btn-secondary"
              onClick={() => {
                setDiscountReasonModalOpen(false);
                setDiscountRevisionReason("");
              }}
            >
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={!discountRevisionReason.trim() || applyingDiscount}
              onClick={handleApplyAllDiscounts}
            >
              {applyingDiscount ? "Applying..." : "Apply Discount"}
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 4 }}>
          <label style={{ fontWeight: 600, fontSize: 13, display: "block", marginBottom: 6 }}>
            Reason for Discount
          </label>
          <Input.TextArea
            rows={3}
            placeholder="Enter reason for discount"
            value={discountRevisionReason}
            onChange={(e: any) => setDiscountRevisionReason(e.target.value)}
            style={{ borderRadius: 4 }}
          />
        </div>
      </AntModal>

      </Content>
    </>
  );
};

const RejectPo = ({ isModalVisible, setIsModalVisible, rejectTender }: any) => {
  const [form] = Form.useForm();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        const reason = values.reason;
        rejectTender(reason); // Call your reject function here
        form.resetFields();
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <AntModal
      title="Reject Tender"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Submit"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical" name="rejectForm">
        <Form.Item
          name="reason"
          label="Reason for rejection"
          rules={[{ required: true, message: "Please input your reason!" }]}
        >
          <Input.TextArea placeholder="Type your reason here..." />
        </Form.Item>
      </Form>
    </AntModal>
  );
};
export default ViewTenderDetails;
